/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.4 routes of UserInterviewsRailsServer::Application.
 * @version d0a987668f152f9e6702712e5010d9342dddb98aa036d1410ff0eff60b9a4ac9
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {"protocol":"https","trailing_slash":false},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: false,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /accounts/:account_id/api-keys(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_api_keys_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"api-keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:account_id/api-keys(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_api_keys_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"api-keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/availability-settings(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_availability_settings_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"availability-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:account_id/availability-settings(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_availability_settings_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"availability-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/billing(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_billing_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:account_id/billing(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_billing_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_calendar_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_calendar_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /researcher(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_dashboard_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"researcher"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /researcher(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"researcher"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /accounts/:id/admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_dashboard_admin_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:id/admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_dashboard_admin_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_dashboard_redirect_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_dashboard_redirect_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /researcher/start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_dashboard_start_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"researcher"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /researcher/start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_dashboard_start_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"researcher"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/forgot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_forgot_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"forgot"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/forgot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_forgot_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"forgot"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/integrations(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:account_id/integrations(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_integrations_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/prepaid-balances/:id(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_prepaid_balance_url = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:account_id/prepaid-balances/:id(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_prepaid_balance_path = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/prepaid-balances(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_prepaid_balances_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prepaid-balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:account_id/prepaid-balances(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_prepaid_balances_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prepaid-balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/resend-team-verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_resend_team_verification_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"resend-team-verification"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/resend-team-verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_resend_team_verification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"resend-team-verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_signin_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_signin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_signup_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_signup_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accounts_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accounts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /participants/:id/admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_participant_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:id/admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_participant_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signin_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_signin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/access-grants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_access_grant_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"access-grants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/access-grants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_access_grant_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"access-grants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/access-grants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_access_grants_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"access-grants"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/access-grants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_access_grants_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"access-grants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/signup-info(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_account_signup_infos_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"signup-info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/signup-info(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_account_signup_infos_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"signup-info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/api-keys(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_api_keys_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"api-keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/api-keys(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_api_keys_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"api-keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/availability-settings(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_availability_settings_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"availability-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/availability-settings(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_availability_settings_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"availability-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/checklist(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_checklists_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"checklist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/checklist(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_checklists_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"checklist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/account-collaborators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_collaborators_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"account-collaborators"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/account-collaborators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_collaborators_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"account-collaborators"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/default-card(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_default_card_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"default-card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/default-card(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_default_card_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"default-card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/email-subscription(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_email_subscription_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"email-subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/email-subscription(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_email_subscription_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"email-subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/integrations/:integration_provider/tasks(.:format)
 * @param {any} account_id
 * @param {any} integration_provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_integration_tasks_url = /*#__PURE__*/ __route({"account_id":{"r":true},"integration_provider":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/integrations/:integration_provider/tasks(.:format)
 * @param {any} account_id
 * @param {any} integration_provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_integration_tasks_path = /*#__PURE__*/ __route({"account_id":{"r":true},"integration_provider":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_provider"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/integrations(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_integrations_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/integrations(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_integrations_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/mcp-connections(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_mcp_connections_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"mcp-connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/mcp-connections(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_mcp_connections_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"mcp-connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/account-oauth-tokens/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_oauth_token_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"account-oauth-tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/account-oauth-tokens/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_oauth_token_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"account-oauth-tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/account-one-time-passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_one_time_passwords_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"account-one-time-passwords"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/account-one-time-passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_one_time_passwords_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"account-one-time-passwords"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/project-task-events/:id(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_project_task_event_url = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"project-task-events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/project-task-events/:id(.:format)
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_project_task_event_path = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"project-task-events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/project-task-events(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_project_task_events_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"project-task-events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/project-task-events(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_project_task_events_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"project-task-events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/projects(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_projects_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/projects(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_projects_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/stripe-cards(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_stripe_cards_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"stripe-cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/stripe-cards(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_stripe_cards_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"stripe-cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts/:account_id/teams(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_teams_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts/:account_id/teams(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_teams_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_accounts_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_accounts_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/ada-chat-metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ada_chat_metadata_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"ada-chat-metadata"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/ada-chat-metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ada_chat_metadata_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"ada-chat-metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/authorization-user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_authorization_user_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"authorization-user"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/authorization-user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_authorization_user_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"authorization-user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/bulk-emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_bulk_emails_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"bulk-emails"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/bulk-emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_bulk_emails_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"bulk-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_comment_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_comment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/commenters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_commenters_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"commenters"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/commenters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_commenters_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"commenters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_comments_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_comments_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/custom-emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_custom_email_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom-emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/custom-emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_custom_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom-emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/custom_emails/:custom_email_id/preview(.:format)
 * @param {any} custom_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_custom_email_previews_url = /*#__PURE__*/ __route({"custom_email_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom_emails"],[2,[7,"/"],[2,[3,"custom_email_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/custom_emails/:custom_email_id/preview(.:format)
 * @param {any} custom_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_custom_email_previews_path = /*#__PURE__*/ __route({"custom_email_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom_emails"],[2,[7,"/"],[2,[3,"custom_email_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/custom-emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_custom_emails_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom-emails"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/custom-emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_custom_emails_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/data-task-attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/data-task-attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/data-task-attempts/:data_task_attempt_id/recordings/:id(.:format)
 * @param {any} data_task_attempt_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_data_task_recording_url = /*#__PURE__*/ __route({"data_task_attempt_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"data_task_attempt_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/data-task-attempts/:data_task_attempt_id/recordings/:id(.:format)
 * @param {any} data_task_attempt_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_data_task_recording_path = /*#__PURE__*/ __route({"data_task_attempt_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"data_task_attempt_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/data-task-attempts/:data_task_attempt_id/recordings/:data_task_recording_id/part-uploads(.:format)
 * @param {any} data_task_attempt_id
 * @param {any} data_task_recording_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_data_task_recording_part_uploads_url = /*#__PURE__*/ __route({"data_task_attempt_id":{"r":true},"data_task_recording_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"data_task_attempt_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"data_task_recording_id"],[2,[7,"/"],[2,[6,"part-uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/data-task-attempts/:data_task_attempt_id/recordings/:data_task_recording_id/part-uploads(.:format)
 * @param {any} data_task_attempt_id
 * @param {any} data_task_recording_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_data_task_recording_part_uploads_path = /*#__PURE__*/ __route({"data_task_attempt_id":{"r":true},"data_task_recording_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"data_task_attempt_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"data_task_recording_id"],[2,[7,"/"],[2,[6,"part-uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/data-task-attempts/:data_task_attempt_id/recordings(.:format)
 * @param {any} data_task_attempt_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_data_task_recordings_url = /*#__PURE__*/ __route({"data_task_attempt_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"data_task_attempt_id"],[2,[7,"/"],[2,[6,"recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/data-task-attempts/:data_task_attempt_id/recordings(.:format)
 * @param {any} data_task_attempt_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_data_task_recordings_path = /*#__PURE__*/ __route({"data_task_attempt_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"data_task_attempt_id"],[2,[7,"/"],[2,[6,"recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/data-task-attempts/:data_task_attempt_id/retake(.:format)
 * @param {any} data_task_attempt_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_retake_url = /*#__PURE__*/ __route({"data_task_attempt_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"data_task_attempt_id"],[2,[7,"/"],[2,[6,"retake"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/data-task-attempts/:data_task_attempt_id/retake(.:format)
 * @param {any} data_task_attempt_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_attempt_retake_path = /*#__PURE__*/ __route({"data_task_attempt_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-task-attempts"],[2,[7,"/"],[2,[3,"data_task_attempt_id"],[2,[7,"/"],[2,[6,"retake"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/data-tasks/:data_task_slug/release-agreements(.:format)
 * @param {any} data_task_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_data_release_agreements_url = /*#__PURE__*/ __route({"data_task_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-tasks"],[2,[7,"/"],[2,[3,"data_task_slug"],[2,[7,"/"],[2,[6,"release-agreements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/data-tasks/:data_task_slug/release-agreements(.:format)
 * @param {any} data_task_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_data_release_agreements_path = /*#__PURE__*/ __route({"data_task_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-tasks"],[2,[7,"/"],[2,[3,"data_task_slug"],[2,[7,"/"],[2,[6,"release-agreements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/data-tasks/:data_task_slug/participants(.:format)
 * @param {any} data_task_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_participants_url = /*#__PURE__*/ __route({"data_task_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-tasks"],[2,[7,"/"],[2,[3,"data_task_slug"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/data-tasks/:data_task_slug/participants(.:format)
 * @param {any} data_task_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_task_participants_path = /*#__PURE__*/ __route({"data_task_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-tasks"],[2,[7,"/"],[2,[3,"data_task_slug"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/data-tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_tasks_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-tasks"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/data-tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_data_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"data-tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/feature_flags/:feature_name(.:format)
 * @param {any} feature_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_feature_flag_url = /*#__PURE__*/ __route({"feature_name":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/feature_flags/:feature_name(.:format)
 * @param {any} feature_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_feature_flag_path = /*#__PURE__*/ __route({"feature_name":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/ledger-entries-data-exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ledger_entries_data_exports_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"ledger-entries-data-exports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/ledger-entries-data-exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ledger_entries_data_exports_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"ledger-entries-data-exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/llm-chats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_llm_chat_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/llm-chats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_llm_chat_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/llm-chats/:llm_chat_id/llm-messages(.:format)
 * @param {any} llm_chat_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_llm_chat_llm_messages_url = /*#__PURE__*/ __route({"llm_chat_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-chats"],[2,[7,"/"],[2,[3,"llm_chat_id"],[2,[7,"/"],[2,[6,"llm-messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/llm-chats/:llm_chat_id/llm-messages(.:format)
 * @param {any} llm_chat_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_llm_chat_llm_messages_path = /*#__PURE__*/ __route({"llm_chat_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-chats"],[2,[7,"/"],[2,[3,"llm_chat_id"],[2,[7,"/"],[2,[6,"llm-messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/llm-chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_llm_chats_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-chats"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/llm-chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_llm_chats_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-chats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/llm-messages/:llm_message_id/llm-message-ratings(.:format)
 * @param {any} llm_message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_llm_message_llm_message_ratings_url = /*#__PURE__*/ __route({"llm_message_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-messages"],[2,[7,"/"],[2,[3,"llm_message_id"],[2,[7,"/"],[2,[6,"llm-message-ratings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/llm-messages/:llm_message_id/llm-message-ratings(.:format)
 * @param {any} llm_message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_llm_message_llm_message_ratings_path = /*#__PURE__*/ __route({"llm_message_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-messages"],[2,[7,"/"],[2,[3,"llm_message_id"],[2,[7,"/"],[2,[6,"llm-message-ratings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/meeting-bots/:meeting_bot_id/transcript-speakers(.:format)
 * @param {any} meeting_bot_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_meeting_bot_transcript_speakers_url = /*#__PURE__*/ __route({"meeting_bot_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"meeting-bots"],[2,[7,"/"],[2,[3,"meeting_bot_id"],[2,[7,"/"],[2,[6,"transcript-speakers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/meeting-bots/:meeting_bot_id/transcript-speakers(.:format)
 * @param {any} meeting_bot_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_meeting_bot_transcript_speakers_path = /*#__PURE__*/ __route({"meeting_bot_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"meeting-bots"],[2,[7,"/"],[2,[3,"meeting_bot_id"],[2,[7,"/"],[2,[6,"transcript-speakers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/occupation-groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_occupation_group_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"occupation-groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/occupation-groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_occupation_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"occupation-groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/occupation-groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_occupation_groups_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"occupation-groups"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/occupation-groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_occupation_groups_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"occupation-groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/occupations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_occupations_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"occupations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/occupations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_occupations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"occupations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-population-opt-in-forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_opt_in_form_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-population-opt-in-forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-population-opt-in-forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_opt_in_form_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-population-opt-in-forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-population-opt-in-forms/:opt_in_form_id/duplicates(.:format)
 * @param {any} opt_in_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_opt_in_form_duplicates_url = /*#__PURE__*/ __route({"opt_in_form_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-population-opt-in-forms"],[2,[7,"/"],[2,[3,"opt_in_form_id"],[2,[7,"/"],[2,[6,"duplicates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-population-opt-in-forms/:opt_in_form_id/duplicates(.:format)
 * @param {any} opt_in_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_opt_in_form_duplicates_path = /*#__PURE__*/ __route({"opt_in_form_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-population-opt-in-forms"],[2,[7,"/"],[2,[3,"opt_in_form_id"],[2,[7,"/"],[2,[6,"duplicates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-population-opt-in-forms/:opt_in_form_id/participants(.:format)
 * @param {any} opt_in_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_opt_in_form_participants_url = /*#__PURE__*/ __route({"opt_in_form_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-population-opt-in-forms"],[2,[7,"/"],[2,[3,"opt_in_form_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-population-opt-in-forms/:opt_in_form_id/participants(.:format)
 * @param {any} opt_in_form_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_opt_in_form_participants_path = /*#__PURE__*/ __route({"opt_in_form_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-population-opt-in-forms"],[2,[7,"/"],[2,[3,"opt_in_form_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/accounts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_accounts_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/accounts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/branding_settings(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_branding_settings_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"branding_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/branding_settings(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_branding_settings_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"branding_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/data-consent-notice(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_data_consent_notice_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"data-consent-notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/data-consent-notice(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_data_consent_notice_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"data-consent-notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/email-themes/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_email_theme_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/email-themes/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_email_theme_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/email-themes/:id/preview(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_email_theme_preview_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/email-themes/:id/preview(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_email_theme_preview_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/email-themes(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_email_themes_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"email-themes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/email-themes(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_email_themes_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"email-themes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/filterable-population-panels(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_filterable_population_panels_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"filterable-population-panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/filterable-population-panels(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_filterable_population_panels_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"filterable-population-panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/hub-usage(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_hub_usage_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"hub-usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/hub-usage(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_hub_usage_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"hub-usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organization-members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_member_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organization-members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_member_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/memberships(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_memberships_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/memberships(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_memberships_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/oauth-configurations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_oauth_configurations_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"oauth-configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/oauth-configurations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_oauth_configurations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"oauth-configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/page-theme(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_page_theme_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"page-theme"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/page-theme(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_page_theme_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"page-theme"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/participants/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_participant_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/participants/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_participant_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/population-panels/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_population_panel_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"population-panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/population-panels/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_population_panel_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"population-panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/population-panels(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_population_panels_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"population-panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/population-panels(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_population_panels_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"population-panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/project-custom-email-sets/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_project_custom_email_set_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"project-custom-email-sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/project-custom-email-sets/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_project_custom_email_set_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"project-custom-email-sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/project-custom-email-sets/:id/duplicate(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_project_custom_email_set_duplicate_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"project-custom-email-sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/project-custom-email-sets/:id/duplicate(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_project_custom_email_set_duplicate_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"project-custom-email-sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/project-custom-email-sets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_project_custom_email_sets_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"project-custom-email-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/project-custom-email-sets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_project_custom_email_sets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"project-custom-email-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_projects_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_reports_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/roles(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_roles_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/roles(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_roles_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/teams/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_team_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/teams/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_team_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/team_invitations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_team_invitations_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/team_invitations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_team_invitations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/team-project-templates(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_team_project_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-project-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/team-project-templates(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_team_project_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-project-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/teams(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_teams_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/teams(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_teams_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/template-items/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_template_item_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"template-items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/template-items/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_template_item_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"template-items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/template-items(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_template_items_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"template-items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/template-items(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_template_items_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"template-items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organizations_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organizations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_attributes_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-attributes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_attributes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-data-exports/:data_job_id(.:format)
 * @param {any} data_job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_data_export_url = /*#__PURE__*/ __route({"data_job_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-data-exports"],[2,[7,"/"],[2,[3,"data_job_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-data-exports/:data_job_id(.:format)
 * @param {any} data_job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_data_export_path = /*#__PURE__*/ __route({"data_job_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-data-exports"],[2,[7,"/"],[2,[3,"data_job_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-data-exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_data_exports_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-data-exports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-data-exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_data_exports_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-data-exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/dismissed_participant_projects(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_dismissed_participant_projects_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"dismissed_participant_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/dismissed_participant_projects(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_dismissed_participant_projects_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"dismissed_participant_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/fraud_data_summary(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_fraud_data_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"fraud_data_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/fraud_data_summary(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_fraud_data_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"fraud_data_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/general-referral-stats(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_general_referral_stats_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"general-referral-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/general-referral-stats(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_general_referral_stats_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"general-referral-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-incentives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_incentive_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-incentives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-incentives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_incentive_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-incentives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-incentives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_incentives_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-incentives"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-incentives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_incentives_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-incentives"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/participant_incentives/redeemables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_incentives_redeemables_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redeemables"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant_incentives/redeemables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_incentives_redeemables_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redeemables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_incentives_redemptions_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_incentives_redemptions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/messages(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_messages_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/messages(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_messages_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/notes(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_notes_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/notes(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_notes_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/onboarding-validation(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_onboarding_validation_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"onboarding-validation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/onboarding-validation(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_onboarding_validation_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"onboarding-validation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-one-time-passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_one_time_passwords_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-one-time-passwords"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-one-time-passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_one_time_passwords_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-one-time-passwords"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/participant-population-attribute-values(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_participant_population_attribute_values_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"participant-population-attribute-values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/participant-population-attribute-values(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_participant_population_attribute_values_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"participant-population-attribute-values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/phone-number-reverification(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_phone_number_reverification_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"phone-number-reverification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/phone-number-reverification(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_phone_number_reverification_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"phone-number-reverification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/phone-number-verification(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_phone_number_verification_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"phone-number-verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/phone-number-verification(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_phone_number_verification_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"phone-number-verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-attributes/:id(.:format)
 * @param {any} participant_population_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_attribute_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-attributes/:id(.:format)
 * @param {any} participant_population_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_attribute_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-population-attributes/:participant_population_attribute_id/values(.:format)
 * @param {any} participant_population_attribute_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_attribute_participant_population_attribute_values_url = /*#__PURE__*/ __route({"participant_population_attribute_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-population-attributes"],[2,[7,"/"],[2,[3,"participant_population_attribute_id"],[2,[7,"/"],[2,[6,"values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-population-attributes/:participant_population_attribute_id/values(.:format)
 * @param {any} participant_population_attribute_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_attribute_participant_population_attribute_values_path = /*#__PURE__*/ __route({"participant_population_attribute_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-population-attributes"],[2,[7,"/"],[2,[3,"participant_population_attribute_id"],[2,[7,"/"],[2,[6,"values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-attributes(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_attributes_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-attributes(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_attributes_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/account-hub-configurations(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_hub_configs_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"account-hub-configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/account-hub-configurations(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_hub_configs_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"account-hub-configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/invite-filters/:id(.:format)
 * @param {any} participant_population_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_invite_filter_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"invite-filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/invite-filters/:id(.:format)
 * @param {any} participant_population_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_invite_filter_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"invite-filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/invite-filters(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_invite_filters_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"invite-filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/invite-filters(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_invite_filters_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"invite-filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-labels(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_labels_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-labels(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_labels_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-opt-in-forms(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_opt_in_forms_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-opt-in-forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-opt-in-forms(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_opt_in_forms_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-opt-in-forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participants(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_participants_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participants(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_participants_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/segments/:id(.:format)
 * @param {any} participant_population_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_segment_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/segments/:id(.:format)
 * @param {any} participant_population_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_segment_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/segments/:segment_id/duplicate(.:format)
 * @param {any} participant_population_id
 * @param {any} segment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_segment_duplicate_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"segment_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"segment_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/segments/:segment_id/duplicate(.:format)
 * @param {any} participant_population_id
 * @param {any} segment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_segment_duplicate_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"segment_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"segment_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/segments(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_segments_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"segments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/segments(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_population_segments_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"segments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/projects/:id(.:format)
 * @param {any} participant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_project_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/projects/:id(.:format)
 * @param {any} participant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_project_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/project-participants(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_project_participants_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"project-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/project-participants(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_project_participants_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"project-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/projects(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_projects_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/projects(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_projects_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/prospective-referral(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_prospective_referral_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"prospective-referral"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/prospective-referral(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_prospective_referral_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"prospective-referral"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/reverification-code(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_reverification_code_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"reverification-code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/reverification-code(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_reverification_code_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"reverification-code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/survey-response-sets(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_survey_response_sets_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"survey-response-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/survey-response-sets(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_survey_response_sets_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"survey-response-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:participant_id/verification-code(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_verification_code_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"verification-code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:participant_id/verification-code(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participant_verification_code_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"verification-code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participants_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_participants_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/population-panels/:population_panel_id/participants(.:format)
 * @param {any} population_panel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_population_panel_participants_url = /*#__PURE__*/ __route({"population_panel_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"population-panels"],[2,[7,"/"],[2,[3,"population_panel_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/population-panels/:population_panel_id/participants(.:format)
 * @param {any} population_panel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_population_panel_participants_path = /*#__PURE__*/ __route({"population_panel_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"population-panels"],[2,[7,"/"],[2,[3,"population_panel_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/population-panels/participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_population_panels_participants_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"population-panels"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/population-panels/participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_population_panels_participants_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"population-panels"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/pre-applications/:pre_application_slug/checks/:check_slug/recording(.:format)
 * @param {any} pre_application_slug
 * @param {any} check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_pre_application_check_recording_url = /*#__PURE__*/ __route({"pre_application_slug":{"r":true},"check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"pre-applications"],[2,[7,"/"],[2,[3,"pre_application_slug"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"check_slug"],[2,[7,"/"],[2,[6,"recording"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/pre-applications/:pre_application_slug/checks/:check_slug/recording(.:format)
 * @param {any} pre_application_slug
 * @param {any} check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_pre_application_check_recording_path = /*#__PURE__*/ __route({"pre_application_slug":{"r":true},"check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"pre-applications"],[2,[7,"/"],[2,[3,"pre_application_slug"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"check_slug"],[2,[7,"/"],[2,[6,"recording"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/pre-applications/:pre_application_slug/checks/:check_slug/submission(.:format)
 * @param {any} pre_application_slug
 * @param {any} check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_pre_application_check_submission_url = /*#__PURE__*/ __route({"pre_application_slug":{"r":true},"check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"pre-applications"],[2,[7,"/"],[2,[3,"pre_application_slug"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"check_slug"],[2,[7,"/"],[2,[6,"submission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/pre-applications/:pre_application_slug/checks/:check_slug/submission(.:format)
 * @param {any} pre_application_slug
 * @param {any} check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_pre_application_check_submission_path = /*#__PURE__*/ __route({"pre_application_slug":{"r":true},"check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"pre-applications"],[2,[7,"/"],[2,[3,"pre_application_slug"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"check_slug"],[2,[7,"/"],[2,[6,"submission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/prepaid_balance_accounts/:id(.:format)
 * @param {any} prepaid_balance_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_account_url = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"prepaid_balance_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/prepaid_balance_accounts/:id(.:format)
 * @param {any} prepaid_balance_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_account_path = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"prepaid_balance_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/prepaid_balance_accounts(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_accounts_url = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"prepaid_balance_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/prepaid_balance_accounts(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_accounts_path = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"prepaid_balance_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/invitations/:id(.:format)
 * @param {any} prepaid_balance_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_invitation_url = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/invitations/:id(.:format)
 * @param {any} prepaid_balance_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_invitation_path = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/invitations(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_invitations_url = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/invitations(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_invitations_path = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/transactions/:id(.:format)
 * @param {any} prepaid_balance_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_transaction_url = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"transactions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/transactions/:id(.:format)
 * @param {any} prepaid_balance_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_transaction_path = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"transactions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/transactions(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_transactions_url = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/transactions(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balance_transactions_path = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balances_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepaid_balances_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai-moderated-interview-clips(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_clips_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai-moderated-interview-clips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai-moderated-interview-clips(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_clips_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai-moderated-interview-clips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai-moderated-interview-observations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_observations_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai-moderated-interview-observations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai-moderated-interview-observations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_observations_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai-moderated-interview-observations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview_recordings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_recordings_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview_recordings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_recordings_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview_turns(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_turns_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview_turns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview_turns(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_moderated_interview_turns_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview_turns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai-settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_settings_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai-settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_ai_settings_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-authorizations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_authorizations_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-authorizations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_authorizations_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/availability-blocks(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_blocks_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"availability-blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/availability-blocks(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_blocks_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"availability-blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/meeting-bots/:id/download_transcript(.:format)
 * @param {any} project_availability_range_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_download_transcript_meeting_bot_url = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"meeting-bots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_transcript"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/meeting-bots/:id/download_transcript(.:format)
 * @param {any} project_availability_range_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_download_transcript_meeting_bot_path = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"meeting-bots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_transcript"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/meeting-bots/:id(.:format)
 * @param {any} project_availability_range_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_meeting_bot_url = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"meeting-bots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/meeting-bots/:id(.:format)
 * @param {any} project_availability_range_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_meeting_bot_path = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"meeting-bots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/meeting-bots(.:format)
 * @param {any} project_availability_range_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_meeting_bots_url = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"meeting-bots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/meeting-bots(.:format)
 * @param {any} project_availability_range_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_meeting_bots_path = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"meeting-bots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/session-observations(.:format)
 * @param {any} project_availability_range_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_session_observations_url = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"session-observations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/session-observations(.:format)
 * @param {any} project_availability_range_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_session_observations_path = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"session-observations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/session-roles(.:format)
 * @param {any} project_availability_range_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_session_roles_url = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"session-roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-availability-ranges/:project_availability_range_id/session-roles(.:format)
 * @param {any} project_availability_range_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_range_session_roles_path = /*#__PURE__*/ __route({"project_availability_range_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"project_availability_range_id"],[2,[7,"/"],[2,[6,"session-roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/availability-settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_settings_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"availability-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/availability-settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_availability_settings_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"availability-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/charges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_charges_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"charges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/charges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_charges_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"charges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/close_requests(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_close_requests_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"close_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/close_requests(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_close_requests_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"close_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/collaborators/:collaborator_id/calendar-events(.:format)
 * @param {any} project_id
 * @param {any} collaborator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_collaborator_calendar_events_url = /*#__PURE__*/ __route({"project_id":{"r":true},"collaborator_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[3,"collaborator_id"],[2,[7,"/"],[2,[6,"calendar-events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/collaborators/:collaborator_id/calendar-events(.:format)
 * @param {any} project_id
 * @param {any} collaborator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_collaborator_calendar_events_path = /*#__PURE__*/ __route({"project_id":{"r":true},"collaborator_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[3,"collaborator_id"],[2,[7,"/"],[2,[6,"calendar-events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/collaborators(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_collaborators_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/collaborators(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_collaborators_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/collaborators/admin-add-self(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_collaborators_admin_add_self_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"admin-add-self"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/collaborators/admin-add-self(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_collaborators_admin_add_self_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"admin-add-self"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/cost-breakdowns(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_cost_breakdowns_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"cost-breakdowns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/cost-breakdowns(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_cost_breakdowns_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"cost-breakdowns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/criteria(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_criteria_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/criteria(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_criteria_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project_custom_email_sets/:project_custom_email_set_id/project-custom-emails(.:format)
 * @param {any} project_custom_email_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_custom_email_set_project_custom_emails_url = /*#__PURE__*/ __route({"project_custom_email_set_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project_custom_email_sets"],[2,[7,"/"],[2,[3,"project_custom_email_set_id"],[2,[7,"/"],[2,[6,"project-custom-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project_custom_email_sets/:project_custom_email_set_id/project-custom-emails(.:format)
 * @param {any} project_custom_email_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_custom_email_set_project_custom_emails_path = /*#__PURE__*/ __route({"project_custom_email_set_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project_custom_email_sets"],[2,[7,"/"],[2,[3,"project_custom_email_set_id"],[2,[7,"/"],[2,[6,"project-custom-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/custom-emails(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_custom_emails_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"custom-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/custom-emails(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_custom_emails_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"custom-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-dashboard-summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_dashboard_summaries_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-dashboard-summaries"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-dashboard-summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_dashboard_summaries_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-dashboard-summaries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/data-jobs(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_data_jobs_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"data-jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/data-jobs(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_data_jobs_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"data-jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/default-session-roles(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_default_session_roles_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"default-session-roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/default-session-roles(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_default_session_roles_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"default-session-roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/demographic-rules(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_demographic_rules_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"demographic-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/demographic-rules(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_demographic_rules_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"demographic-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/discounts(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_discounts_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/discounts(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_discounts_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/discussion-guide(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_discussion_guide_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"discussion-guide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/discussion-guide(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_discussion_guide_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"discussion-guide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/discussion-topics(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_discussion_topics_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"discussion-topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/discussion-topics(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_discussion_topics_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"discussion-topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/dope-tables/:table_name/columns(.:format)
 * @param {any} project_id
 * @param {any} table_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_dope_table_columns_url = /*#__PURE__*/ __route({"project_id":{"r":true},"table_name":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"dope-tables"],[2,[7,"/"],[2,[3,"table_name"],[2,[7,"/"],[2,[6,"columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/dope-tables/:table_name/columns(.:format)
 * @param {any} project_id
 * @param {any} table_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_dope_table_columns_path = /*#__PURE__*/ __route({"project_id":{"r":true},"table_name":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"dope-tables"],[2,[7,"/"],[2,[3,"table_name"],[2,[7,"/"],[2,[6,"columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/draft-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_draft_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"draft-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/draft-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_draft_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"draft-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/duplicate(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_duplicate_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/duplicate(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_duplicate_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/eligible_participant_count(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_eligible_participant_count_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"eligible_participant_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/eligible_participant_count(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_eligible_participant_count_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"eligible_participant_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/email-stats(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_email_stats_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"email-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/email-stats(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_email_stats_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"email-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/expected-cost-details(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_expected_cost_details_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"expected-cost-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/expected-cost-details(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_expected_cost_details_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"expected-cost-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/file_uploads(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_file_uploads_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/file_uploads(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_file_uploads_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"file_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/insights-discussion-guide(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_insights_discussion_guide_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights-discussion-guide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/insights-discussion-guide(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_insights_discussion_guide_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights-discussion-guide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/interview-recordings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_interview_recordings_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"interview-recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/interview-recordings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_interview_recordings_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"interview-recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/invites(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_invites_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/invites(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_invites_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/invoices(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_invoices_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/invoices(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_invoices_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/launch(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_launch_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/launch(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_launch_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project_listings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_listing_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project_listings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project_listings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_listing_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project_listings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project_listings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_listings_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project_listings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/project_listings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_listings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project_listings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/meeting-bots(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_meeting_bots_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"meeting-bots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/meeting-bots(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_meeting_bots_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"meeting-bots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/messagers/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_messager_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messagers"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/messagers/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_messager_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messagers"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/messagers(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_messagers_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messagers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/messagers(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_messagers_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messagers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/messages(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_messages_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/messages(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_messages_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/messages-bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_messages_bulk_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messages-bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/messages-bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_messages_bulk_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messages-bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/notifications(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_notifications_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/notifications(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_notifications_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/notifications/test(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_notifications_test_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/notifications/test(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_notifications_test_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/occupation-group-links(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_occupation_group_links_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"occupation-group-links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/occupation-group-links(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_occupation_group_links_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"occupation-group-links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/occupation-links(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_occupation_links_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"occupation-links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/occupation-links(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_occupation_links_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"occupation-links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/open_calendar_time_ranges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_open_calendar_time_ranges_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"open_calendar_time_ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/open_calendar_time_ranges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_open_calendar_time_ranges_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"open_calendar_time_ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/availability_ranges(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_availability_ranges_url = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"availability_ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/availability_ranges(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_availability_ranges_path = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"availability_ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/document-details(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_document_detail_url = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"document-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/document-details(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_document_detail_path = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"document-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-fraud-reports/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_fraud_report_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-fraud-reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-fraud-reports/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_fraud_report_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-fraud-reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-fraud-reports(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_fraud_reports_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-fraud-reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-fraud-reports(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_fraud_reports_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-fraud-reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/invited-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_management_invited_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"invited-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/invited-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_management_invited_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"invited-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/population-panel-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_management_population_panel_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"population-panel-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/population-panel-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_management_population_panel_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"population-panel-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/shortlisted-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_management_shortlisted_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"shortlisted-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/shortlisted-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_management_shortlisted_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"shortlisted-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/project-participant-tags/:id(.:format)
 * @param {any} project_participant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_project_participant_tag_url = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"project-participant-tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/project-participant-tags/:id(.:format)
 * @param {any} project_participant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_project_participant_tag_path = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"project-participant-tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/project-participant-tags(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_project_participant_tags_url = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"project-participant-tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/project-participant-tags(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_project_participant_tags_path = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"project-participant-tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/schedulable-ranges(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_schedulable_ranges_url = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"schedulable-ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/schedulable-ranges(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_schedulable_ranges_path = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"schedulable-ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/scheduled-range(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_scheduled_range_url = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"scheduled-range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/scheduled-range(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_scheduled_range_path = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"scheduled-range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/views(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_views_url = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/:project_participant_id/views(.:format)
 * @param {any} project_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participant_views_path = /*#__PURE__*/ __route({"project_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"project_participant_id"],[2,[7,"/"],[2,[6,"views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/application-status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participants_application_status_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[6,"application-status"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/application-status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participants_application_status_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[6,"application-status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project-participants/video-uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participants_video_upload_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[6,"video-uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project-participants/video-uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participants_video_upload_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[6,"video-uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participation_details(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participation_details_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participation_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participation_details(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_participation_details_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participation_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/payment-methods(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_payment_methods_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"payment-methods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/payment-methods(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_payment_methods_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"payment-methods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-ranges/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_availability_range_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-ranges/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_availability_range_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-range-calendar-events(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_availability_range_calendar_events_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-range-calendar-events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-range-calendar-events(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_availability_range_calendar_events_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-range-calendar-events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-ranges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_availability_ranges_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-ranges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_availability_ranges_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-participants/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-participants/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-participants"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-scores(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_scores_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-scores(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_scores_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-signup-pages(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_sessions_signup_pages_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-signup-pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-signup-pages(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_sessions_signup_pages_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-signup-pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-setup-validations/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_setup_validation_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-setup-validations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-setup-validations/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_setup_validation_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-setup-validations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-setup-validations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_setup_validations_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-setup-validations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-setup-validations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_setup_validations_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-setup-validations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-skills(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_skills_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-skills"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-skills(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_skills_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-skills"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-tasks(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_tasks_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-tasks(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_project_tasks_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/proposed-availability-ranges/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_proposed_availability_range_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"proposed-availability-ranges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/proposed-availability-ranges/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_proposed_availability_range_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"proposed-availability-ranges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/proposed-availability-range-collections(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_proposed_availability_range_collections_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"proposed-availability-range-collections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/proposed-availability-range-collections(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_proposed_availability_range_collections_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"proposed-availability-range-collections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/proposed-availability-ranges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_proposed_availability_ranges_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"proposed-availability-ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/proposed-availability-ranges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_proposed_availability_ranges_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"proposed-availability-ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/quotas/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_quota_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"quotas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/quotas/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_quota_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"quotas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/quota-summaries(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_quota_summaries_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"quota-summaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/quota-summaries(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_quota_summaries_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"quota-summaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/quotas(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_quotas_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/quotas(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_quotas_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/recruit-feasibility(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_recruit_feasibility_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"recruit-feasibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/recruit-feasibility(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_recruit_feasibility_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"recruit-feasibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/reels/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_reel_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"reels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/reels/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_reel_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"reels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/reels(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_reels_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"reels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/reels(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_reels_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"reels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/schedulable-ranges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_schedulable_ranges_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"schedulable-ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/schedulable-ranges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_schedulable_ranges_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"schedulable-ranges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/scheduled-invites-settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_scheduled_invites_settings_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"scheduled-invites-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/scheduled-invites-settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_scheduled_invites_settings_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"scheduled-invites-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/score(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_score_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"score"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/score(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_score_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"score"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-sessions/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-sessions/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-clips/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_clip_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-clips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-clips/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_clip_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-clips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-clips(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_clips_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-clips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-clips(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_clips_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-clips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-observations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_observations_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-observations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-observations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_observations_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-observations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-pricing(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_pricing_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/session-pricing(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_session_pricing_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"session-pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-sessions(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_sessions_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-sessions(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_sessions_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_settings_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_settings_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/signature-request-downloads(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_signature_request_downloads_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"signature-request-downloads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/signature-request-downloads(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_signature_request_downloads_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"signature-request-downloads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/status_updates(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_status_updates_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"status_updates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/status_updates(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_status_updates_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"status_updates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/summary(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_summary_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/summary(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_summary_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/survey(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_survey_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/survey(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_survey_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/surveys/:survey_id/external-response-sets(.:format)
 * @param {any} project_id
 * @param {any} survey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_survey_external_response_sets_url = /*#__PURE__*/ __route({"project_id":{"r":true},"survey_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"survey_id"],[2,[7,"/"],[2,[6,"external-response-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/surveys/:survey_id/external-response-sets(.:format)
 * @param {any} project_id
 * @param {any} survey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_survey_external_response_sets_path = /*#__PURE__*/ __route({"project_id":{"r":true},"survey_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"survey_id"],[2,[7,"/"],[2,[6,"external-response-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/survey-preview-sections(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_survey_preview_sections_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"survey-preview-sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/survey-preview-sections(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_survey_preview_sections_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"survey-preview-sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/surveys(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_surveys_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/surveys(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_surveys_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/tags/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_tag_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/tags/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_tag_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/tags(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_tags_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/tags(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_tags_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/project_tasks/:project_task_id/participant-task-event-stats(.:format)
 * @param {any} project_task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_task_participant_task_event_stats_url = /*#__PURE__*/ __route({"project_task_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project_tasks"],[2,[7,"/"],[2,[3,"project_task_id"],[2,[7,"/"],[2,[6,"participant-task-event-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/project_tasks/:project_task_id/participant-task-event-stats(.:format)
 * @param {any} project_task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_task_participant_task_event_stats_path = /*#__PURE__*/ __route({"project_task_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"project_tasks"],[2,[7,"/"],[2,[3,"project_task_id"],[2,[7,"/"],[2,[6,"participant-task-event-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/task-setting(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_task_setting_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"task-setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/task-setting(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_task_setting_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"task-setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/workspace-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_workspace_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"workspace-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/workspace-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_workspace_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"workspace-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_projects_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_projects_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_qualification_check_ai_moderated_interview_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_qualification_check_ai_moderated_interview_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview_recordings(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_qualification_check_ai_moderated_interview_recordings_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview_recordings(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_qualification_check_ai_moderated_interview_recordings_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview_turns(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_qualification_check_ai_moderated_interview_turns_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview_turns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview_turns(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_qualification_check_ai_moderated_interview_turns_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview_turns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-check-attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_qualification_check_attempt_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-check-attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-check-attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_qualification_check_attempt_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-check-attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/redshift-triggers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_redshift_trigger_response_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"redshift-triggers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/redshift-triggers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_redshift_trigger_response_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"redshift-triggers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/researcher-notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_researcher_note_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"researcher-notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/researcher-notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_researcher_note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"researcher-notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/researcher-notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_researcher_notes_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"researcher-notes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/researcher-notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_researcher_notes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"researcher-notes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/response-sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_response_set_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"response-sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/response-sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_response_set_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"response-sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/response-sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_response_sets_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"response-sets"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/response-sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_response_sets_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"response-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/session-observers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_session_observers_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"session-observers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/session-observers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_session_observers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"session-observers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/sessions/:session_id/project_participants(.:format)
 * @param {any} session_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_session_project_participants_url = /*#__PURE__*/ __route({"session_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"session_id"],[2,[7,"/"],[2,[6,"project_participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/sessions/:session_id/project_participants(.:format)
 * @param {any} session_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_session_project_participants_path = /*#__PURE__*/ __route({"session_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"session_id"],[2,[7,"/"],[2,[6,"project_participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/session-signup-pages/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_session_signup_pages_sessions_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"session-signup-pages"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/session-signup-pages/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_session_signup_pages_sessions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"session-signup-pages"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/signature-request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_signature_request_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"signature-request"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/signature-request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_signature_request_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"signature-request"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/signature-request/sign-url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_signature_request_sign_url_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"signature-request"],[2,[7,"/"],[2,[6,"sign-url"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/signature-request/sign-url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_signature_request_sign_url_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"signature-request"],[2,[7,"/"],[2,[6,"sign-url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/skills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_skills_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"skills"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/skills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_skills_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"skills"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/sku-prices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_sku_price_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"sku-prices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/sku-prices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_sku_price_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"sku-prices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/staff_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_staff_note_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"staff_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/staff_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_staff_note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"staff_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/staff_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_staff_notes_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"staff_notes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/staff_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_staff_notes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"staff_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/surveys/:survey_id/response-sets(.:format)
 * @param {any} survey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_survey_response_sets_url = /*#__PURE__*/ __route({"survey_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"survey_id"],[2,[7,"/"],[2,[6,"response-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/surveys/:survey_id/response-sets(.:format)
 * @param {any} survey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_survey_response_sets_path = /*#__PURE__*/ __route({"survey_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"survey_id"],[2,[7,"/"],[2,[6,"response-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/surveys/:survey_id/sections(.:format)
 * @param {any} survey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_survey_survey_sections_url = /*#__PURE__*/ __route({"survey_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"survey_id"],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/surveys/:survey_id/sections(.:format)
 * @param {any} survey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_survey_survey_sections_path = /*#__PURE__*/ __route({"survey_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"survey_id"],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/task-settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_task_setting_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"task-settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/task-settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_task_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"task-settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/billing_infos(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_billing_infos_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"billing_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/billing_infos(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_billing_infos_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"billing_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/enrichment(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_enrichment_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"enrichment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/enrichment(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_enrichment_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"enrichment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/invites/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_invite_url = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/invites/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_invite_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/invites(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_invites_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/invites(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_invites_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/ledger-entries(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_ledger_entries_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"ledger-entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/ledger-entries(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_ledger_entries_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"ledger-entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/logos(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_logos_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"logos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/logos(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_logos_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"logos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/team-members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_member_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/team-members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_member_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/team-members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_members_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-members"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/team-members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_members_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-members"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/organization-subscriptions(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_organization_subscription_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"organization-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/organization-subscriptions(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_organization_subscription_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"organization-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/page-contents/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_page_content_url = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"page-contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/page-contents/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_page_content_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"page-contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/page-contents(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_page_contents_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"page-contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/page-contents(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_page_contents_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"page-contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/participants/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_participant_url = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/participants/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_participant_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/past-participants(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_past_participants_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"past-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/past-participants(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_past_participants_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"past-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/projects(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_projects_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/projects(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_projects_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/recruit-balance(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_recruit_balances_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"recruit-balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/recruit-balance(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_recruit_balances_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"recruit-balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/roles(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_roles_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/roles(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_roles_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/saml-configurations/:saml_configuration_id(.:format)
 * @param {any} team_id
 * @param {any} saml_configuration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_saml_configuration_url = /*#__PURE__*/ __route({"team_id":{"r":true},"saml_configuration_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"saml-configurations"],[2,[7,"/"],[2,[3,"saml_configuration_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/saml-configurations/:saml_configuration_id(.:format)
 * @param {any} team_id
 * @param {any} saml_configuration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_saml_configuration_path = /*#__PURE__*/ __route({"team_id":{"r":true},"saml_configuration_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"saml-configurations"],[2,[7,"/"],[2,[3,"saml_configuration_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/saml-configurations(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_saml_configurations_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"saml-configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/saml-configurations(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_saml_configurations_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"saml-configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/settings(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_settings_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/settings(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_settings_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/chargebee-subscriptions(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_chargebee_subscriptions_url = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"chargebee-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/chargebee-subscriptions(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_chargebee_subscriptions_path = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"chargebee-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/recruit-allowance-schedule(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_recruit_allowance_schedule_url = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"recruit-allowance-schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/recruit-allowance-schedule(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_recruit_allowance_schedule_path = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"recruit-allowance-schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/sku-price-summaries(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_sku_price_summaries_url = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"sku-price-summaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/sku-price-summaries(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_sku_price_summaries_path = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"sku-price-summaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/sku-prices(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_sku_prices_url = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"sku-prices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/sku-prices(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_sku_prices_path = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"sku-prices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/versions(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_versions_url = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/team-subscriptions/:team_subscription_id/versions(.:format)
 * @param {any} team_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscription_versions_path = /*#__PURE__*/ __route({"team_subscription_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"team_subscription_id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/cancel(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_cancel_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/cancel(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_cancel_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/legacy-migration(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_legacy_migration_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"legacy-migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/legacy-migration(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_legacy_migration_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"legacy-migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/open_recruit_period(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_open_recruit_period_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"open_recruit_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/open_recruit_period(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_open_recruit_period_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"open_recruit_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/pause(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_pause_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/pause(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_pause_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/recruit_periods/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_recruit_period_url = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"recruit_periods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/recruit_periods/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_recruit_period_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"recruit_periods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/recruit_periods(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_recruit_periods_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"recruit_periods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/subscriptions/recruit_periods(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_subscriptions_recruit_periods_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"recruit_periods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/members(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_team_members_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/members(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_team_members_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/team-project-templates/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_team_project_template_url = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"team-project-templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/team-project-templates/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_team_project_template_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"team-project-templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams/:team_id/team-project-templates(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_team_project_templates_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"team-project-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams/:team_id/team-project-templates(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_team_project_templates_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"team-project-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_teams_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_teams_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_users_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_users_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/recruit-participants/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_bulk_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruit-participants/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_bulk_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/characteristics/:characteristic_id/options(.:format)
 * @param {any} characteristic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_characteristic_options_url = /*#__PURE__*/ __route({"characteristic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"characteristics"],[2,[7,"/"],[2,[3,"characteristic_id"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/characteristics/:characteristic_id/options(.:format)
 * @param {any} characteristic_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_characteristic_options_path = /*#__PURE__*/ __route({"characteristic_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"characteristics"],[2,[7,"/"],[2,[3,"characteristic_id"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/characteristics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_characteristics_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"characteristics"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/characteristics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_characteristics_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"characteristics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_participant_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_participant_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_participants_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_participants_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/batches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_participants_batch_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/batches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_participants_batch_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/batches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_participants_batches_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"batches"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/batches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_participants_batches_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"batches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid_balances/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_prepaid_balance_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid_balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid_balances/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_prepaid_balance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid_balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid_balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_prepaid_balances_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid_balances"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid_balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_prepaid_balances_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/close-requests(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_close_requests_url = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"close-requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/close-requests(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_close_requests_path = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"close-requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/expected_costs(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_expected_costs_url = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"expected_costs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/expected_costs(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_expected_costs_path = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"expected_costs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruit-feasibility(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_feasibility_index_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-feasibility"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruit-feasibility(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_feasibility_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-feasibility"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/launches(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_launches_url = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"launches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/launches(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_launches_path = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"launches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/participants/:id(.:format)
 * @param {any} recruit_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_url = /*#__PURE__*/ __route({"recruit_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/participants/:id(.:format)
 * @param {any} recruit_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_path = /*#__PURE__*/ __route({"recruit_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruit-participants/:recruit_participant_id/fraud-reports(.:format)
 * @param {any} recruit_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_fraud_reports_url = /*#__PURE__*/ __route({"recruit_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[3,"recruit_participant_id"],[2,[7,"/"],[2,[6,"fraud-reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruit-participants/:recruit_participant_id/fraud-reports(.:format)
 * @param {any} recruit_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_fraud_reports_path = /*#__PURE__*/ __route({"recruit_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[3,"recruit_participant_id"],[2,[7,"/"],[2,[6,"fraud-reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/participant-invitations(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_invitations_url = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"participant-invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/participant-invitations(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_invitations_path = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"participant-invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruit-participants/:recruit_participant_id/messages(.:format)
 * @param {any} recruit_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_messages_url = /*#__PURE__*/ __route({"recruit_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[3,"recruit_participant_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruit-participants/:recruit_participant_id/messages(.:format)
 * @param {any} recruit_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_messages_path = /*#__PURE__*/ __route({"recruit_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[3,"recruit_participant_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruit-participants/:recruit_participant_id/screener-responses(.:format)
 * @param {any} recruit_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_screener_responses_url = /*#__PURE__*/ __route({"recruit_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[3,"recruit_participant_id"],[2,[7,"/"],[2,[6,"screener-responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruit-participants/:recruit_participant_id/screener-responses(.:format)
 * @param {any} recruit_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_screener_responses_path = /*#__PURE__*/ __route({"recruit_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[3,"recruit_participant_id"],[2,[7,"/"],[2,[6,"screener-responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruit-participants/:recruit_participant_id/sessions(.:format)
 * @param {any} recruit_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_sessions_url = /*#__PURE__*/ __route({"recruit_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[3,"recruit_participant_id"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruit-participants/:recruit_participant_id/sessions(.:format)
 * @param {any} recruit_participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participant_sessions_path = /*#__PURE__*/ __route({"recruit_participant_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruit-participants"],[2,[7,"/"],[2,[3,"recruit_participant_id"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/participants(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participants_url = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/participants(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_participants_path = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/pauses(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_pauses_url = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"pauses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits/:recruit_id/pauses(.:format)
 * @param {any} recruit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruit_pauses_path = /*#__PURE__*/ __route({"recruit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[2,[7,"/"],[2,[3,"recruit_id"],[2,[7,"/"],[2,[6,"pauses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruitment_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruitment_group_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruitment_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruitment_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruitment_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruitment_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruitment_groups/:recruitment_group_id/expected_costs(.:format)
 * @param {any} recruitment_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruitment_group_expected_costs_url = /*#__PURE__*/ __route({"recruitment_group_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruitment_groups"],[2,[7,"/"],[2,[3,"recruitment_group_id"],[2,[7,"/"],[2,[6,"expected_costs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruitment_groups/:recruitment_group_id/expected_costs(.:format)
 * @param {any} recruitment_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruitment_group_expected_costs_path = /*#__PURE__*/ __route({"recruitment_group_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruitment_groups"],[2,[7,"/"],[2,[3,"recruitment_group_id"],[2,[7,"/"],[2,[6,"expected_costs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/recruitment_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruitment_groups_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruitment_groups"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruitment_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruitment_groups_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruitment_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/recruits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruits_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/recruits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_recruits_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"recruits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/who-am-i(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_who_am_i_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"who-am-i"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/who-am-i(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_who_am_i_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"who-am-i"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support-topic/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-topic"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support-topic/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-topic"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog-category(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_category_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog-category"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /blog-category(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_category_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog-category"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blog/seven-common-screener-survey-mistakes-and-how-to-fix-them(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_screener_mistakes_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"seven-common-screener-survey-mistakes-and-how-to-fix-them"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /blog/seven-common-screener-survey-mistakes-and-how-to-fix-them(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_screener_mistakes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"seven-common-screener-survey-mistakes-and-how-to-fix-them"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog-tag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_tag_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog-tag"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /blog-tag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_tag_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"blog-tag"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /support/byo-page-branding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const branding_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"byo-page-branding"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/byo-page-branding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const branding_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"byo-page-branding"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /browse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browse_projects_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"browse"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /browse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browse_projects_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"browse"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /browse-support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browse_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"browse-support"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /browse-support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browse_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"browse-support"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/access-grants/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_access_grants_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"access-grants"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/access-grants/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_access_grants_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"access-grants"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/meeting-bots/:meeting_bot_id/transcript-speakers/bulk(.:format)
 * @param {any} meeting_bot_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_meeting_bot_transcript_speakers_url = /*#__PURE__*/ __route({"meeting_bot_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"meeting-bots"],[2,[7,"/"],[2,[3,"meeting_bot_id"],[2,[7,"/"],[2,[6,"transcript-speakers"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/meeting-bots/:meeting_bot_id/transcript-speakers/bulk(.:format)
 * @param {any} meeting_bot_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_meeting_bot_transcript_speakers_path = /*#__PURE__*/ __route({"meeting_bot_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"meeting-bots"],[2,[7,"/"],[2,[3,"meeting_bot_id"],[2,[7,"/"],[2,[6,"transcript-speakers"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_participant_incentives_redemptions_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_participant_incentives_redemptions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-labels/bulk(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_participant_population_labels_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-labels"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-population-labels/bulk(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_participant_population_labels_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-population-labels"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-labels/bulk(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_participant_population_participant_labels_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-labels"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant-populations/:participant_population_id/participant-labels/bulk(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_participant_population_participant_labels_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"participant-labels"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/collaborators/bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_project_collaborators_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/collaborators/bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_project_collaborators_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/dope-table-columns/bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_project_dope_table_columns_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"dope-table-columns"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/dope-table-columns/bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_project_dope_table_columns_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"dope-table-columns"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/shortlisted-participants/bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_project_participant_management_shortlisted_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"shortlisted-participants"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/shortlisted-participants/bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_project_participant_management_shortlisted_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"shortlisted-participants"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-ranges/bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_project_project_availability_ranges_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-ranges/bulk(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_project_project_availability_ranges_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-ranges"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/session-observers/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_session_observers_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"session-observers"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/session-observers/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_api_session_observers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"session-observers"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/shortlisted-participants/bulk-delete-subset(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_delete_subset_api_project_participant_management_shortlisted_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"shortlisted-participants"],[2,[7,"/"],[2,[6,"bulk-delete-subset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participant-management/shortlisted-participants/bulk-delete-subset(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_delete_subset_api_project_participant_management_shortlisted_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[6,"shortlisted-participants"],[2,[7,"/"],[2,[6,"bulk-delete-subset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-range-calendar-events/bulk-destroy(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_api_project_project_availability_range_calendar_events_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-range-calendar-events"],[2,[7,"/"],[2,[6,"bulk-destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-availability-range-calendar-events/bulk-destroy(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_api_project_project_availability_range_calendar_events_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-availability-range-calendar-events"],[2,[7,"/"],[2,[6,"bulk-destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants/bulk_message(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_message_api_project_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"bulk_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants/bulk_message(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_message_api_project_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"bulk_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants/bulk_report(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_report_api_project_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"bulk_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants/bulk_report(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_report_api_project_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"bulk_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions/:id/bulk_reward_link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_reward_link_api_participant_incentives_redemption_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_reward_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions/:id/bulk_reward_link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_reward_link_api_participant_incentives_redemption_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_reward_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organization-members/bulk-update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_api_organization_members_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[6,"bulk-update"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organization-members/bulk-update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_api_organization_members_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[6,"bulk-update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants/bulk_update(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_api_project_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants/bulk_update(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_api_project_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chargebee-dashboard/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chargebee_dashboard_event_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chargebee-dashboard"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /chargebee-dashboard/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chargebee_dashboard_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chargebee-dashboard"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chargebee-dashboard/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chargebee_dashboard_invoice_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chargebee-dashboard"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /chargebee-dashboard/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chargebee_dashboard_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chargebee-dashboard"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chargebee-dashboard/subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chargebee_dashboard_subscription_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chargebee-dashboard"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /chargebee-dashboard/subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chargebee_dashboard_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chargebee-dashboard"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/check_new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_new_messages_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"check_new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /messages/check_new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_new_messages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"check_new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/collaboration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborator_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"collaboration"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/collaboration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborator_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"collaboration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/complete(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_project_ai_moderated_interview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/complete(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_project_ai_moderated_interview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview_recordings/:id/complete(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_project_ai_moderated_interview_recording_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview_recordings/:id/complete(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_project_ai_moderated_interview_recording_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/complete(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_qualification_check_ai_moderated_interview_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/complete(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_qualification_check_ai_moderated_interview_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview_recordings/:id/complete(.:format)
 * @param {any} qualification_check_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_qualification_check_ai_moderated_interview_recording_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview_recordings/:id/complete(.:format)
 * @param {any} qualification_check_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_qualification_check_ai_moderated_interview_recording_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /confluence/assigned-project-coordinator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_assigned_project_coordinator_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"assigned-project-coordinator"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/assigned-project-coordinator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_assigned_project_coordinator_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"assigned-project-coordinator"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/canceled-participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_canceled_participants_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"canceled-participants"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/canceled-participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_canceled_participants_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"canceled-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/charge-project(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_charge_project_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"charge-project"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/charge-project(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_charge_project_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"charge-project"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/email-triggers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_email_triggers_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"email-triggers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/email-triggers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_email_triggers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"email-triggers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/notification-stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_notification_stats_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"notification-stats"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/notification-stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_notification_stats_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"notification-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/notification-targeting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_notification_targeting_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"notification-targeting"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/notification-targeting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_notification_targeting_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"notification-targeting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/payment-information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_payment_information_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"payment-information"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/payment-information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_payment_information_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"payment-information"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/project-dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_project_dashboard_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"project-dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/project-dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_project_dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"project-dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/project-notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_project_notes_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"project-notes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/project-notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_project_notes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"project-notes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/project-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_project_settings_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"project-settings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/project-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_project_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"project-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/project-status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_project_status_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"project-status"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/project-status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_project_status_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"project-status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/qa-form-document(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_qa_form_document_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"qa-form-document"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/qa-form-document(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_qa_form_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"qa-form-document"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/qa-form-private(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_qa_form_private_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"qa-form-private"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/qa-form-private(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_qa_form_private_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"qa-form-private"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/qa-form-public(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_qa_form_public_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"qa-form-public"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/qa-form-public(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_qa_form_public_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"qa-form-public"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/queue-notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_queue_notifications_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"queue-notifications"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/queue-notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_queue_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"queue-notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/subscription-changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_subscription_changes_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"subscription-changes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/subscription-changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_subscription_changes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"subscription-changes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confluence/transfer-participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_transfer_participants_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"transfer-participants"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /confluence/transfer-participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confluence_transfer_participants_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confluence"],[2,[7,"/"],[2,[6,"transfer-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/calendar/connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connect_account_calendar_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/calendar/connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connect_account_calendar_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cookies_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cookies"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cookies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cookies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /accounts/file-uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_file_upload_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"file-uploads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/file-uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_file_upload_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"file-uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_participant_population_search_filter_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_participant_population_search_filter_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/availability-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_account_availability_settings_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"availability-settings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/availability-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_account_availability_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"availability-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_account_billing_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_account_billing_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/setting-up-custom-email-domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_email_domain_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"setting-up-custom-email-domain"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/setting-up-custom-email-domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_email_domain_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"setting-up-custom-email-domain"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/byo-consent-notice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_consent_notice_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"byo-consent-notice"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/byo-consent-notice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_consent_notice_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"byo-consent-notice"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/organization-members/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivate_api_organization_member_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organization-members/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivate_api_organization_member_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/members/deactivated(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivated_organization_members_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"deactivated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/members/deactivated(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivated_organization_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"deactivated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/populations/:participant_population_id/delete(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_population_participants_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/populations/:participant_population_id/delete(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_population_participants_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/details(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_organization_team_subscriptions_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/details(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_organization_team_subscriptions_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/do_not_pay_canceled_participant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const do_not_pay_canceled_participant_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"do_not_pay_canceled_participant"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/do_not_pay_canceled_participant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const do_not_pay_canceled_participant_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"do_not_pay_canceled_participant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/how-do-i-use-document-signing-to-get-my-nda-or-release-form-signed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_signing_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"how-do-i-use-document-signing-to-get-my-nda-or-release-form-signed"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/how-do-i-use-document-signing-to-get-my-nda-or-release-form-signed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_signing_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"how-do-i-use-document-signing-to-get-my-nda-or-release-form-signed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /staff/data-task-recordings/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_staff_data_task_recording_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-task-recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /staff/data-task-recordings/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_staff_data_task_recording_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-task-recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/quotas/:id/duplicate(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_project_quota_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"quotas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/quotas/:id/duplicate(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_project_quota_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"quotas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_prepaid_balance_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_prepaid_balance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/templates/custom-email-sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_custom_email_set_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"custom-email-sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/templates/custom-email-sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_custom_email_set_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"custom-email-sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/templates/custom-email-sets/:project_custom_email_set_id/emails/:id(.:format)
 * @param {any} project_custom_email_set_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_custom_email_set_email_url = /*#__PURE__*/ __route({"project_custom_email_set_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"custom-email-sets"],[2,[7,"/"],[2,[3,"project_custom_email_set_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/templates/custom-email-sets/:project_custom_email_set_id/emails/:id(.:format)
 * @param {any} project_custom_email_set_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_custom_email_set_email_path = /*#__PURE__*/ __route({"project_custom_email_set_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"custom-email-sets"],[2,[7,"/"],[2,[3,"project_custom_email_set_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/question-bank/question-templates/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_question_bank_question_template_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"question-bank"],[2,[7,"/"],[2,[6,"question-templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/question-bank/question-templates/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_question_bank_question_template_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"question-bank"],[2,[7,"/"],[2,[6,"question-templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_team_subscription_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_team_subscription_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/templates/page-template/:pageName(.:format)
 * @param {any} pageName
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_page_template_url = /*#__PURE__*/ __route({"pageName":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"page-template"],[2,[7,"/"],[2,[3,"pageName"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/templates/page-template/:pageName(.:format)
 * @param {any} pageName
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_page_template_path = /*#__PURE__*/ __route({"pageName":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"page-template"],[2,[7,"/"],[2,[3,"pageName"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/page-template/:page_name/edit(.:format)
 * @param {any} organization_id
 * @param {any} page_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_page_template_type_organization_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"page_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"page-template"],[2,[7,"/"],[2,[3,"page_name"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/page-template/:page_name/edit(.:format)
 * @param {any} organization_id
 * @param {any} page_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_page_template_type_organization_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"page_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"page-template"],[2,[7,"/"],[2,[3,"page_name"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participant-populations/:participant_population_id/hub-invite-rules/edit(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_participant_population_invite_filter_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"hub-invite-rules"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /participant-populations/:participant_population_id/hub-invite-rules/edit(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_participant_population_invite_filter_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"hub-invite-rules"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participant-populations/:participant_population_id/opt-in-forms/:id/edit(.:format)
 * @param {any} participant_population_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_participant_population_opt_in_form_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"opt-in-forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /participant-populations/:participant_population_id/opt-in-forms/:id/edit(.:format)
 * @param {any} participant_population_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_participant_population_opt_in_form_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"opt-in-forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/edit-screener-surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_screener_surveys_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"edit-screener-surveys"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/edit-screener-surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_screener_surveys_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"edit-screener-surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/branding/email-themes/edit/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_email_theme_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/branding/email-themes/edit/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_email_theme_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/page-templates/edit/:page_name(.:format)
 * @param {any} page_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_page_template_url = /*#__PURE__*/ __route({"page_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"page-templates"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"page_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/page-templates/edit/:page_name(.:format)
 * @param {any} page_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_page_template_path = /*#__PURE__*/ __route({"page_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"page-templates"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"page_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email-addresses/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_addresses_verify_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"email-addresses"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /email-addresses/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_addresses_verify_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"email-addresses"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/email-sets/:email_set_id(.:format)
 * @param {any} organization_id
 * @param {any} email_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_set_organization_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"email_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"email-sets"],[2,[7,"/"],[2,[3,"email_set_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/email-sets/:email_set_id(.:format)
 * @param {any} organization_id
 * @param {any} email_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_set_organization_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"email_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"email-sets"],[2,[7,"/"],[2,[3,"email_set_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/branding/email-themes/:email_theme_id(.:format)
 * @param {any} organization_id
 * @param {any} email_theme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_theme_organization_branding_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"email_theme_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[3,"email_theme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/branding/email-themes/:email_theme_id(.:format)
 * @param {any} organization_id
 * @param {any} email_theme_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_theme_organization_branding_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"email_theme_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[3,"email_theme_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/email-themes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_theme_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"email-themes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/email-themes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_theme_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"email-themes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/email-sets/:email_set_id/emails/:email_type(.:format)
 * @param {any} organization_id
 * @param {any} email_set_id
 * @param {any} email_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_type_organization_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"email_set_id":{"r":true},"email_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"email-sets"],[2,[7,"/"],[2,[3,"email_set_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"email_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/email-sets/:email_set_id/emails/:email_type(.:format)
 * @param {any} organization_id
 * @param {any} email_set_id
 * @param {any} email_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_type_organization_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"email_set_id":{"r":true},"email_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"email-sets"],[2,[7,"/"],[2,[3,"email_set_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"email_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/llm-chat-actions/:id/execute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_api_llm_chat_action_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-chat-actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/llm-chat-actions/:id/execute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_api_llm_chat_action_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"llm-chat-actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions/fetch_reward_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_reward_link_api_participant_incentives_redemptions_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[2,[7,"/"],[2,[6,"fetch_reward_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions/fetch_reward_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_reward_link_api_participant_incentives_redemptions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[2,[7,"/"],[2,[6,"fetch_reward_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/file-uploads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_upload_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"file-uploads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/file-uploads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_upload_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"file-uploads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/filler(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filler_api_project_ai_moderated_interview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"filler"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/filler(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filler_api_project_ai_moderated_interview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"filler"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/filler(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filler_api_qualification_check_ai_moderated_interview_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"filler"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/filler(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filler_api_qualification_check_ai_moderated_interview_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"filler"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/free-plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_plan_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"free-plan"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/free-plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_plan_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"free-plan"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/calendar/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_account_calendar_events_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/calendar/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_account_calendar_events_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/notification-stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_project_notification_stats_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notification-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/notification-stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_project_notification_stats_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notification-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/incentive-and-currency-options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incentive_and_currency_options_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"incentive-and-currency-options"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/incentive-and-currency-options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incentive_and_currency_options_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"incentive-and-currency-options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lp/ux-research-incentive-calculator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incentive_calculator_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"ux-research-incentive-calculator"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lp/ux-research-incentive-calculator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incentive_calculator_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"ux-research-incentive-calculator"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/incentive-payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incentive_payments_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"incentive-payments"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/incentive-payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incentive_payments_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"incentive-payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/incentive-recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incentive_recommendations_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"incentive-recommendations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/incentive-recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incentive_recommendations_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"incentive-recommendations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/calendar/initiate_disconnect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiate_disconnect_account_calendar_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"initiate_disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/calendar/initiate_disconnect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiate_disconnect_account_calendar_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"initiate_disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/interviews-at-the-same-time(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const interviews_at_the_same_time_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"interviews-at-the-same-time"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/interviews-at-the-same-time(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const interviews_at_the_same_time_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"interviews-at-the-same-time"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/what-are-hub-invite-rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite_rules_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"what-are-hub-invite-rules"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/what-are-hub-invite-rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite_rules_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"what-are-hub-invite-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/invites/join/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_team_url = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"join"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/invites/join/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_team_path = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"join"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/labels/:participant_population_label_id(.:format)
 * @param {any} participant_population_label_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labels_delete_url = /*#__PURE__*/ __route({"participant_population_label_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"participant_population_label_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/labels/:participant_population_label_id(.:format)
 * @param {any} participant_population_label_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labels_delete_path = /*#__PURE__*/ __route({"participant_population_label_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"participant_population_label_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/labels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labels_delete_from_participants_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/labels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labels_delete_from_participants_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/labels/:participant_population_id(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labels_get_for_population_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"participant_population_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/labels/:participant_population_id(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labels_get_for_population_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"participant_population_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/labels/:participant_population_label_id(.:format)
 * @param {any} participant_population_label_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labels_update_url = /*#__PURE__*/ __route({"participant_population_label_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"participant_population_label_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/labels/:participant_population_label_id(.:format)
 * @param {any} participant_population_label_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labels_update_path = /*#__PURE__*/ __route({"participant_population_label_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"participant_population_label_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/launching-a-project(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launching_a_project_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"launching-a-project"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/launching-a-project(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launching_a_project_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"launching-a-project"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/ledger(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ledger_organization_team_subscriptions_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[6,"ledger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/ledger(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ledger_organization_team_subscriptions_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[6,"ledger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/load(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_messages_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"load"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /messages/load(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_messages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"load"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participant-admin-data(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_project_participant_admin_data_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-admin-data"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participant-admin-data(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_project_participant_admin_data_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-admin-data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/manage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_project_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/manage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/access-grants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_access_grant_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"access-grants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/access-grants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_access_grant_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"access-grants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_prepaid_balance_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_prepaid_balance_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/prepaid_balance_accounts/new(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_prepaid_balance_account_url = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"prepaid_balance_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/prepaid_balance_accounts/new(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_prepaid_balance_account_path = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"prepaid_balance_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/invitations/new(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_prepaid_balance_invitation_url = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/prepaid-balances/:prepaid_balance_id/invitations/new(.:format)
 * @param {any} prepaid_balance_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_prepaid_balance_invitation_path = /*#__PURE__*/ __route({"prepaid_balance_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"prepaid_balance_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/status_updates/new(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_project_status_updates_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"status_updates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/status_updates/new(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_project_status_updates_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"status_updates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v2_participant_url = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v2_participant_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/templates/custom-email-sets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_custom_email_set_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"custom-email-sets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/templates/custom-email-sets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_custom_email_set_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"custom-email-sets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/email-sets/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_set_organization_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"email-sets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/email-sets/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_set_organization_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"email-sets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/branding/email-themes/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_theme_organization_branding_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/branding/email-themes/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_theme_organization_branding_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/ledger/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ledger_entry_organization_team_subscriptions_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[6,"ledger"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/ledger/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ledger_entry_organization_team_subscriptions_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[6,"ledger"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/question-bank/question-templates/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_question_bank_question_template_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"question-bank"],[2,[7,"/"],[2,[6,"question-templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/question-bank/question-templates/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_question_bank_question_template_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"question-bank"],[2,[7,"/"],[2,[6,"question-templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_team_subscription_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_team_subscription_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participant-populations/:participant_population_id/opt-in-forms/new(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_participant_population_opt_in_form_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"opt-in-forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /participant-populations/:participant_population_id/opt-in-forms/new(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_participant_population_opt_in_form_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"opt-in-forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/email-templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_project_custom_email_set_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"email-templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/email-templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_project_custom_email_set_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"email-templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/branding/email-themes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_team_email_theme_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/branding/email-themes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_team_email_theme_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[6,"email-themes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/invite-teammates-to-observe-sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observer_signup_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"invite-teammates-to-observe-sessions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/invite-teammates-to-observe-sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observer_signup_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"invite-teammates-to-observe-sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /occupation_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupation_group_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"occupation_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /occupation_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupation_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"occupation_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /occupation_group_occupation_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupation_group_occupation_links_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupation_group_occupation_links"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /occupation_group_occupation_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupation_group_occupation_links_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupation_group_occupation_links"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /occupation_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupation_groups_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupation_groups"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /occupation_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupation_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupation_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /occupations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupations_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupations"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /occupations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /occupations/group-tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupations_group_tags_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupations"],[2,[7,"/"],[2,[6,"group-tags"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /occupations/group-tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupations_group_tags_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupations"],[2,[7,"/"],[2,[6,"group-tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /occupations/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupations_search_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupations"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /occupations/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const occupations_search_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"occupations"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /opt-in/:access_code(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_in_form_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"opt-in"],[2,[7,"/"],[2,[3,"access_code"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /opt-in/:access_code(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_in_form_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"opt-in"],[2,[7,"/"],[2,[3,"access_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /opt-in-forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_in_forms_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"opt-in-forms"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /opt-in-forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_in_forms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"opt-in-forms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /opt-in/:access_code/preview(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_in_preview_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"opt-in"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /opt-in/:access_code/preview(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_in_preview_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"opt-in"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/advanced-options(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_advanced_options_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"advanced-options"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/advanced-options(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_advanced_options_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"advanced-options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/billing(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_billing_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/billing(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_billing_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/branding(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_branding_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/branding(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_branding_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_members_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/plans(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_plans_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/plans(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_plans_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/question-bank/question-templates/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_question_bank_question_template_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"question-bank"],[2,[7,"/"],[2,[6,"question-templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/question-bank/question-templates/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_question_bank_question_template_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"question-bank"],[2,[7,"/"],[2,[6,"question-templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/question-bank/question-templates(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_question_bank_question_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"question-bank"],[2,[7,"/"],[2,[6,"question-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/question-bank/question-templates(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_question_bank_question_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"question-bank"],[2,[7,"/"],[2,[6,"question-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/reports/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_report_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/reports/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_report_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_reports_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/branding(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_branding_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/branding(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_branding_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/edit(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_edit_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/edit(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_edit_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/email-templates(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_email_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/email-templates(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_email_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/members(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_members_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/members(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/notes(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_notes_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:team_id/notes(.:format)
 * @param {any} organization_id
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_notes_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_subscription_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_subscription_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_subscriptions_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/team-subscriptions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_subscriptions_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_teams_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_teams_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizations_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /teams/templates/page-template/:pageName/preview(.:format)
 * @param {any} pageName
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_template_url = /*#__PURE__*/ __route({"pageName":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"page-template"],[2,[7,"/"],[2,[3,"pageName"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/templates/page-template/:pageName/preview(.:format)
 * @param {any} pageName
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_template_path = /*#__PURE__*/ __route({"pageName":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"page-template"],[2,[7,"/"],[2,[3,"pageName"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participant/confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_confirmation_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participant/confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_confirmation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participant-contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_contact_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participant-contact"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /participant-contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_contact_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participant-contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /participants/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_dashboard_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/forgot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_forgot_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"forgot"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/forgot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_forgot_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"forgot"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /r/:general_referral_code(.:format)
 * @param {any} general_referral_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_general_referral_code_url = /*#__PURE__*/ __route({"general_referral_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"general_referral_code"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /r/:general_referral_code(.:format)
 * @param {any} general_referral_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_general_referral_code_path = /*#__PURE__*/ __route({"general_referral_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"general_referral_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /join/:referrer(.:format)
 * @param {any} referrer
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_join_path_url = /*#__PURE__*/ __route({"referrer":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"join"],[2,[7,"/"],[2,[3,"referrer"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /join/:referrer(.:format)
 * @param {any} referrer
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_join_path_path = /*#__PURE__*/ __route({"referrer":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"join"],[2,[7,"/"],[2,[3,"referrer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/linkedin-verification-intercept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_linkedin_verification_intercept_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"linkedin-verification-intercept"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/linkedin-verification-intercept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_linkedin_verification_intercept_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"linkedin-verification-intercept"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/:participant_id/messages(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_messages_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:participant_id/messages(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_messages_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/onboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_onboard_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"onboard"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/onboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_onboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"onboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/phone/reverify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_phone_number_reverification_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"phone"],[2,[7,"/"],[2,[6,"reverify"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/phone/reverify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_phone_number_reverification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"phone"],[2,[7,"/"],[2,[6,"reverify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/phone/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_phone_number_verification_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"phone"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/phone/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_phone_number_verification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"phone"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/what-policies-should-i-be-aware-of-as-a-participant(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_policies_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"what-policies-should-i-be-aware-of-as-a-participant"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/what-policies-should-i-be-aware-of-as-a-participant(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_policies_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"what-policies-should-i-be-aware-of-as-a-participant"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participant-populations/:participant_population_id/opt-in-forms(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_population_opt_in_forms_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"opt-in-forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participant-populations/:participant_population_id/opt-in-forms(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_population_opt_in_forms_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participant-populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"opt-in-forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/:participant_id/profiles(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_population_profile_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:participant_id/profiles(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_population_profile_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/:participant_id/profiles/edit(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_population_profile_edit_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:participant_id/profiles/edit(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_population_profile_edit_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/forgot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_process_forgot_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"forgot"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/forgot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_process_forgot_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"forgot"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_process_reset_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_process_reset_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/:id/product-and-service-details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_product_and_service_details_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product-and-service-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:id/product-and-service-details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_product_and_service_details_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product-and-service-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/:id/professional-details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_professional_details_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"professional-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:id/professional-details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_professional_details_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"professional-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/profile(/*path)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_profile_url = /*#__PURE__*/ __route({"path":{},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"profile"],[2,[1,[2,[7,"/"],[5,[3,"path"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/profile(/*path)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_profile_path = /*#__PURE__*/ __route({"path":{},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"profile"],[2,[1,[2,[7,"/"],[5,[3,"path"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /participant-recruitment-guide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_recruitment_guide_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participant-recruitment-guide"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /participant-recruitment-guide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_recruitment_guide_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participant-recruitment-guide"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /participants/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_referrals_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_referrals_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_reset_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_reset_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/:id/responses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_responses_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:id/responses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_responses_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/:id/security-preferences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_security_preferences_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"security-preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:id/security-preferences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_security_preferences_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"security-preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_signin_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_signin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/signout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_signout_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"signout"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/signout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_signout_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"signout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_signup_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_signup_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participant-studies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_studies_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participant-studies"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /participant-studies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_studies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participant-studies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /support-category/participant-resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-category"],[2,[7,"/"],[2,[6,"participant-resources"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support-category/participant-resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-category"],[2,[7,"/"],[2,[6,"participant-resources"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/:id/technical-details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_technical_details_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"technical-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:id/technical-details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_technical_details_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"technical-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /legal/participant-terms-and-conditions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_terms_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[2,[6,"participant-terms-and-conditions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /legal/participant-terms-and-conditions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[2,[6,"participant-terms-and-conditions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/:id/text-messages(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_text_messages_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"text-messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:id/text-messages(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_text_messages_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"text-messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_welcome_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participant_welcome_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /participants/connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_connect_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_connect_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_edit_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_edit_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/:participant_id/notifications(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_notifications_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:participant_id/notifications(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_notifications_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/:participant_id/unsubscribe(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_unsubscribe_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:participant_id/unsubscribe(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participants_unsubscribe_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/pre-applications/:pre_application_slug/checks/:check_slug/recording/parts(.:format)
 * @param {any} pre_application_slug
 * @param {any} check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parts_api_pre_application_check_recording_url = /*#__PURE__*/ __route({"pre_application_slug":{"r":true},"check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"pre-applications"],[2,[7,"/"],[2,[3,"pre_application_slug"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"check_slug"],[2,[7,"/"],[2,[6,"recording"],[2,[7,"/"],[2,[6,"parts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/pre-applications/:pre_application_slug/checks/:check_slug/recording/parts(.:format)
 * @param {any} pre_application_slug
 * @param {any} check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parts_api_pre_application_check_recording_path = /*#__PURE__*/ __route({"pre_application_slug":{"r":true},"check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"pre-applications"],[2,[7,"/"],[2,[3,"pre_application_slug"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"check_slug"],[2,[7,"/"],[2,[6,"recording"],[2,[7,"/"],[2,[6,"parts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview_recordings/:id/parts(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parts_api_project_ai_moderated_interview_recording_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"parts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview_recordings/:id/parts(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parts_api_project_ai_moderated_interview_recording_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"parts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview_recordings/:id/parts(.:format)
 * @param {any} qualification_check_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parts_api_qualification_check_ai_moderated_interview_recording_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"parts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview_recordings/:id/parts(.:format)
 * @param {any} qualification_check_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parts_api_qualification_check_ai_moderated_interview_recording_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview_recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"parts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/pause(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_api_project_ai_moderated_interview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/pause(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_api_project_ai_moderated_interview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/pause(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_api_qualification_check_ai_moderated_interview_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/pause(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_api_qualification_check_ai_moderated_interview_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/pay_canceled_participant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pay_canceled_project_participant_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pay_canceled_participant"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/pay_canceled_participant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pay_canceled_project_participant_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pay_canceled_participant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/members/pending(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_organization_members_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"pending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/members/pending(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_organization_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"pending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_account_signin_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_account_signin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/populations/:participant_population_id/import(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_import_participants_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/populations/:participant_population_id/import(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_import_participants_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_participant_signin_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_participant_signin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /staff/data-task-recordings/:id/playback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playback_staff_data_task_recording_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-task-recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"playback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /staff/data-task-recordings/:id/playback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playback_staff_data_task_recording_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-task-recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"playback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/populations/:participant_population_id/attributes(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const population_attributes_get_for_population_url = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/populations/:participant_population_id/attributes(.:format)
 * @param {any} participant_population_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const population_attributes_get_for_population_path = /*#__PURE__*/ __route({"participant_population_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"populations"],[2,[7,"/"],[2,[3,"participant_population_id"],[2,[7,"/"],[2,[6,"attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/post-account-creation(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_account_creation_url = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"post-account-creation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:account_id/post-account-creation(.:format)
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_account_creation_path = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"post-account-creation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/post-account-creation/:step(.:format)
 * @param {any} account_id
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_account_creation_step_url = /*#__PURE__*/ __route({"account_id":{"r":true},"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"post-account-creation"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:account_id/post-account-creation/:step(.:format)
 * @param {any} account_id
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_account_creation_step_path = /*#__PURE__*/ __route({"account_id":{"r":true},"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"post-account-creation"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /prepaid-balances/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepaid_balance_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /prepaid-balances/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepaid_balance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prepaid-balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/prepaid-balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepaid_balance_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"prepaid-balances"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/prepaid-balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepaid_balance_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"prepaid-balances"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prepaid-balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepaid_balances_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"prepaid-balances"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /prepaid-balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepaid_balances_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"prepaid-balances"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/page-template/:page_name/preview(.:format)
 * @param {any} organization_id
 * @param {any} page_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_page_template_type_organization_templates_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"page_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"page-template"],[2,[7,"/"],[2,[3,"page_name"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /organizations/:organization_id/templates/page-template/:page_name/preview(.:format)
 * @param {any} organization_id
 * @param {any} page_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_page_template_type_organization_templates_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"page_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"page-template"],[2,[7,"/"],[2,[3,"page_name"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/apply(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_projects_apply_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/apply(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_projects_apply_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /surveys/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_survey_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /surveys/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_survey_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pricing_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pricing_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:access_code/application(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:access_code/application(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:access_code/application/finish(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_finish_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:access_code/application/finish(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_finish_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:access_code/application/profile(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_profile_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:access_code/application/profile(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_profile_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:access_code/application/survey(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_survey_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[2,[7,"/"],[2,[6,"survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:access_code/application/survey(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_survey_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[2,[7,"/"],[2,[6,"survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:access_code/application/video(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_video_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[2,[7,"/"],[2,[6,"video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:access_code/application/video(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_application_video_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"application"],[2,[7,"/"],[2,[6,"video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/email-templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_custom_email_set_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"email-templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/email-templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_custom_email_set_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"email-templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/email-templates/:project_custom_email_set_id/custom_emails/:id(.:format)
 * @param {any} project_custom_email_set_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_custom_email_set_custom_email_url = /*#__PURE__*/ __route({"project_custom_email_set_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"email-templates"],[2,[7,"/"],[2,[3,"project_custom_email_set_id"],[2,[7,"/"],[2,[6,"custom_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/email-templates/:project_custom_email_set_id/custom_emails/:id(.:format)
 * @param {any} project_custom_email_set_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_custom_email_set_custom_email_path = /*#__PURE__*/ __route({"project_custom_email_set_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"email-templates"],[2,[7,"/"],[2,[3,"project_custom_email_set_id"],[2,[7,"/"],[2,[6,"custom_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /studies(/*filter_types)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_listings_url = /*#__PURE__*/ __route({"filter_types":{},"format":{}}, [2,[7,"/"],[2,[6,"studies"],[2,[1,[2,[7,"/"],[5,[3,"filter_types"]]]],[1,[2,[8,"."],[3,"format"]]]]]], true);

/**
 * Generates rails route to
 * /studies(/*filter_types)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_listings_path = /*#__PURE__*/ __route({"filter_types":{},"format":{}}, [2,[7,"/"],[2,[6,"studies"],[2,[1,[2,[7,"/"],[5,[3,"filter_types"]]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /studies/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_listings_referrals_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"studies"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /studies/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_listings_referrals_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"studies"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support-topic/project-management(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_management_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-topic"],[2,[7,"/"],[2,[6,"project-management"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support-topic/project-management(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_management_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-topic"],[2,[7,"/"],[2,[6,"project-management"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/occupations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_occupations_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"occupations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/occupations(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_occupations_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"occupations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_messages_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_messages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participant/availability(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_availability_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participant/availability(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_availability_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participant/schedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_enroll_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participant/schedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_enroll_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participants/:participant_id/propose-times(.:format)
 * @param {any} id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_propose_times_url = /*#__PURE__*/ __route({"id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"propose-times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participants/:participant_id/propose-times(.:format)
 * @param {any} id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_propose_times_path = /*#__PURE__*/ __route({"id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"propose-times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participant/reschedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_reschedule_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participant/reschedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_reschedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participant/sign-up(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_sign_up_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"sign-up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participant/sign-up(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_sign_up_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[6,"sign-up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participants/:participant_id/update-timezone(.:format)
 * @param {any} id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_update_timezone_url = /*#__PURE__*/ __route({"id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"update-timezone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participants/:participant_id/update-timezone(.:format)
 * @param {any} id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participant_scheduling_update_timezone_path = /*#__PURE__*/ __route({"id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"update-timezone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants/invite-download(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participants_invite_download_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"invite-download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants/invite-download(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_participants_invite_download_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"invite-download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/screener_form_success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_screener_form_success_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"screener_form_success"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/screener_form_success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_screener_form_success_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"screener_form_success"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/sessions/join(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_sessions_join_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/sessions/join(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_sessions_join_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sessions-signup-pages/:uuid(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_sessions_signup_page_url = /*#__PURE__*/ __route({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sessions-signup-pages"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sessions-signup-pages/:uuid(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_sessions_signup_page_path = /*#__PURE__*/ __route({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sessions-signup-pages"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sessions-signup-pages/:uuid/preview(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_sessions_signup_page_preview_url = /*#__PURE__*/ __route({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sessions-signup-pages"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sessions-signup-pages/:uuid/preview(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_sessions_signup_page_preview_path = /*#__PURE__*/ __route({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sessions-signup-pages"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project-task-events/:provider(/:event_type)(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_task_events_url = /*#__PURE__*/ __route({"provider":{"r":true},"event_type":{},"format":{}}, [2,[7,"/"],[2,[6,"project-task-events"],[2,[7,"/"],[2,[3,"provider"],[2,[1,[2,[7,"/"],[3,"event_type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /project-task-events/:provider(/:event_type)(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_task_events_path = /*#__PURE__*/ __route({"provider":{"r":true},"event_type":{},"format":{}}, [2,[7,"/"],[2,[6,"project-task-events"],[2,[7,"/"],[2,[3,"provider"],[2,[1,[2,[7,"/"],[3,"event_type"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/unmoderated-sessions/join(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_unmoderated_sessions_join_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"unmoderated-sessions"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/unmoderated-sessions/join(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_unmoderated_sessions_join_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"unmoderated-sessions"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/unmoderated-sessions/opt-out(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_unmoderated_sessions_opt_out_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"unmoderated-sessions"],[2,[7,"/"],[2,[6,"opt-out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/unmoderated-sessions/opt-out(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_unmoderated_sessions_opt_out_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"unmoderated-sessions"],[2,[7,"/"],[2,[6,"opt-out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/update-status(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_status_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update-status"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/update-status(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_update_status_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"update-status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_billing_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/billing(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_billing_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing/participant/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_billing_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/billing/participant/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_billing_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing/participant/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_billing_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/billing/participant/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_billing_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/branding(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_branding_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/branding(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_branding_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/communications(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_communications_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/communications(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_communications_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/communications/preparation-instructions(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_communications_preparation_instructions_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"preparation-instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/communications/preparation-instructions(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_communications_preparation_instructions_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"preparation-instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/method(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_method_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/method(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_method_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/method/task-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_method_task_location_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"method"],[2,[7,"/"],[2,[6,"task-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/method/task-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_method_task_location_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"method"],[2,[7,"/"],[2,[6,"task-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/method/video-response(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_method_video_response_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"method"],[2,[7,"/"],[2,[6,"video-response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/method/video-response(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_method_video_response_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"method"],[2,[7,"/"],[2,[6,"video-response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/overview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_overview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/overview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_overview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/scheduling(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_scheduling_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"scheduling"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/scheduling(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_scheduling_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"scheduling"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/scheduling/availability(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_scheduling_availability_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"scheduling"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/scheduling/availability(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_scheduling_availability_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"scheduling"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/screener(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_screener_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"screener"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/screener(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_screener_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"screener"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/screener/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_screener_edit_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"screener"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/screener/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_screener_edit_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"screener"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/targeting(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_targeting_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"targeting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/targeting(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_targeting_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"targeting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/build/targeting/criteria(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_targeting_criteria_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"targeting"],[2,[7,"/"],[2,[6,"criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/build/targeting/criteria(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_build_targeting_criteria_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[6,"targeting"],[2,[7,"/"],[2,[6,"criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/calendar(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_calendar_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/calendar(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_calendar_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/calendar/attendance-and-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_calendar_attendance_and_location_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"attendance-and-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/calendar/attendance-and-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_calendar_attendance_and_location_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"attendance-and-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/calendar/scheduling-rules(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_calendar_scheduling_rules_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"scheduling-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/calendar/scheduling-rules(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_calendar_scheduling_rules_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"scheduling-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/characteristics(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_characteristics_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"characteristics"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/characteristics(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_characteristics_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"characteristics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/characteristics/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_characteristics_edit_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"characteristics"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/characteristics/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_characteristics_edit_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"characteristics"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/collaborators(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_collaborators_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/collaborators(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_collaborators_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"collaborators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/details(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_details_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/details(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_details_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/emails(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_emails_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/emails(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_emails_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/emails/:email_purpose(.:format)
 * @param {any} project_id
 * @param {any} email_purpose
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_emails_edit_url = /*#__PURE__*/ __route({"project_id":{"r":true},"email_purpose":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"email_purpose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/emails/:email_purpose(.:format)
 * @param {any} project_id
 * @param {any} email_purpose
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_emails_edit_path = /*#__PURE__*/ __route({"project_id":{"r":true},"email_purpose":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"email_purpose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/guided-setup(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_guided_setup_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"guided-setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/guided-setup(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_guided_setup_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"guided-setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/invites(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_invites_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/invites(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_invites_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/invites/invite-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_invites_invite_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"invite-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/invites/invite-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_invites_invite_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"invite-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/messages(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_messages_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/messages(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_messages_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/messages/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_messages_thread_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/messages/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_messages_thread_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/messages/:participant_id/participant(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_messages_thread_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"participant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/messages/:participant_id/participant(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_messages_thread_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"participant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/messages/:participant_id/participant/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_messages_thread_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/messages/:participant_id/participant/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_messages_thread_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/participants/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_participants_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/participants/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_participants_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/participants/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_participants_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/participants/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_participants_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/attendance-and-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_attendance_and_location_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"attendance-and-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/attendance-and-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_attendance_and_location_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"attendance-and-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/availability(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_availability_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/availability(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_availability_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/participant/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/participant/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/participant/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/participant/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/scheduling-rules(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_scheduling_rules_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"scheduling-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/scheduling-rules(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_scheduling_rules_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"scheduling-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/sessions-signup-page-editor(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_sessions_signup_page_editor_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"sessions-signup-page-editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/manage/sessions/sessions-signup-page-editor(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_manage_sessions_sessions_signup_page_editor_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"sessions-signup-page-editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/messages(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_messages_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/messages(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_messages_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/messages/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_messages_thread_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/messages/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_messages_thread_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participant_management_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participant_management_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/tracking(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participant_tracking_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/tracking(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participant_tracking_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/tracking/participant/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participant_tracking_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tracking"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/tracking/participant/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participant_tracking_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tracking"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/tracking/participant/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participant_tracking_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tracking"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/tracking/participant/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participant_tracking_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"tracking"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/availability(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_availability_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/availability(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_availability_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/attendance-and-location(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_scheduled_attendance_and_location_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[6,"attendance-and-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/attendance-and-location(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_scheduled_attendance_and_location_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[6,"attendance-and-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/sessions-signup-page-editor(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_scheduled_sessions_signup_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[6,"sessions-signup-page-editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participant-management/:tertiary_tab/sessions-signup-page-editor(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_funnel_scheduled_sessions_signup_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participant-management"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[6,"sessions-signup-page-editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/invite-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_invite_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"invite-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/invite-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_invite_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"invite-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/characteristics(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_characteristics_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"characteristics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/characteristics(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_characteristics_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"characteristics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/data(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_data_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/data(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_data_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/screener-survey(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_screener_survey_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"screener-survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/screener-survey(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_screener_survey_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"screener-survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/sessions(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_sessions_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/sessions(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_sessions_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_participants_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/discussion-guide(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_discussion_guide_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[6,"discussion-guide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/discussion-guide(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_discussion_guide_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[6,"discussion-guide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/discussion-guide/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_discussion_guide_edit_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[6,"discussion-guide"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/discussion-guide/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_discussion_guide_edit_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[6,"discussion-guide"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/reels/:reel_id(.:format)
 * @param {any} project_id
 * @param {any} reel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_reels_reel_url = /*#__PURE__*/ __route({"project_id":{"r":true},"reel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[6,"reels"],[2,[7,"/"],[2,[3,"reel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/reels/:reel_id(.:format)
 * @param {any} project_id
 * @param {any} reel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_reels_reel_path = /*#__PURE__*/ __route({"project_id":{"r":true},"reel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[6,"reels"],[2,[7,"/"],[2,[3,"reel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/:tertiary_tab(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_tertiary_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[3,"tertiary_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/:tertiary_tab(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_tertiary_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[3,"tertiary_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/:tertiary_tab/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_tetriary_tab_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/:tertiary_tab/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_tetriary_tab_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/:tertiary_tab/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_tetriary_tab_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-analysis/:tertiary_tab/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} tertiary_tab
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_analysis_tetriary_tab_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"tertiary_tab":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-analysis"],[2,[7,"/"],[2,[3,"tertiary_tab"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity/attendance-and-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_attendance_and_location_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"attendance-and-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity/attendance-and-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_attendance_and_location_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"attendance-and-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity/availability(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_availability_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity/availability(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_availability_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity/scheduling-rules(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_scheduling_rules_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"scheduling-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity/scheduling-rules(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_scheduling_rules_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"scheduling-rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity/task-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_task_location_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"task-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/activity/task-location(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_activity_task_location_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"task-location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/communications(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_communications_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/communications(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_communications_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/incentives(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_incentives_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"incentives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/incentives(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_incentives_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"incentives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/additional-details(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_additional_details_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"additional-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/additional-details(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_additional_details_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"additional-details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/chat(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_chat_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/chat(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_chat_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/criteria(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_criteria_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/criteria(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_criteria_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/invite-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_invite_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"invite-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/invite-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_invite_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"invite-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/past-participation(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_past_participation_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"past-participation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/past-participation(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_past_participation_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"past-participation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/request-document-signature(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_request_document_signature_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"request-document-signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/request-document-signature(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_request_document_signature_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"request-document-signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/screener-survey(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_screener_survey_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"screener-survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/screener-survey(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_screener_survey_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"screener-survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/screener-survey/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_screener_survey_edit_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"screener-survey"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/screener-survey/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_screener_survey_edit_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"screener-survey"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/video-response(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_video_response_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"video-response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/research-design/recruitment/video-response(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_research_design_recruitment_video_response_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"research-design"],[2,[7,"/"],[2,[6,"recruitment"],[2,[7,"/"],[2,[6,"video-response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/sessions(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_sessions_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/sessions(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_sessions_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/notifications(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_notifications_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/notifications(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_notifications_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/notifications/emails(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_notifications_emails_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/notifications/emails(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_notifications_emails_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/canceled-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_canceled_participants_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"canceled-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/canceled-participants(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_canceled_participants_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"canceled-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/charges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_charges_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"charges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/charges(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_charges_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"charges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/charges/invoice(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_charges_invoice_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[6,"invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/charges/invoice(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_charges_invoice_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[6,"invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/charges/sync(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_charges_sync_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/charges/sync(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_charges_sync_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/participant/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/participant/:participant_id(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/participant/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_participant_tab_url = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/participant/:participant_id/:active_tab(.:format)
 * @param {any} project_id
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_participant_tab_path = /*#__PURE__*/ __route({"project_id":{"r":true},"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"participant"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/status(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_statuses_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/payments/status(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_payments_statuses_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/qa-overview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_qa_overview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"qa-overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/qa-overview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_qa_overview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"qa-overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/assigned-user(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_assigned_users_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"assigned-user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/assigned-user(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_assigned_users_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"assigned-user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/project-settings/recruitment-fields(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_project_settings_recruitment_fields_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"project-settings"],[2,[7,"/"],[2,[6,"recruitment-fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/project-settings/recruitment-fields(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_project_settings_recruitment_fields_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"project-settings"],[2,[7,"/"],[2,[6,"recruitment-fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/status(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_statuses_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/status(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_statuses_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/survey_keys/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_survey_key_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"survey_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/survey_keys/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_survey_key_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"survey_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/survey_keys(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_survey_keys_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"survey_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/settings/survey_keys(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_settings_survey_keys_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"survey_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/staff/staff-webhooks(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_webhooks_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"staff-webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/staff/staff-webhooks(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_staff_webhooks_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"staff-webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/screener(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_survey_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"screener"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/screener(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_survey_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"screener"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/screener/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_survey_edit_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"screener"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/screener/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_workspace_survey_edit_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"screener"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/accounts/invitations/:code/accept(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_accounts_accept_invitation_url = /*#__PURE__*/ __route({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/accounts/invitations/:code/accept(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_accounts_accept_invitation_path = /*#__PURE__*/ __route({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_accounts_get_accounts_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_accounts_get_accounts_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/accounts/subscribe(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_accounts_subscribe_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/accounts/subscribe(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_accounts_subscribe_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/accounts/unsubscribe(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_accounts_unsubscribe_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/accounts/unsubscribe(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_accounts_unsubscribe_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:access_code/apply(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_apply_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:access_code/apply(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_apply_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/emails(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_emails_create_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/emails(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_emails_create_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/emails/preview-form(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_emails_custom_preview_form_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"preview-form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/emails/preview-form(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_emails_custom_preview_form_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"preview-form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/emails/preview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_emails_preview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/emails/preview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_emails_preview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/emails/:project_custom_email_id(.:format)
 * @param {any} project_custom_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_emails_update_url = /*#__PURE__*/ __route({"project_custom_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"project_custom_email_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/emails/:project_custom_email_id(.:format)
 * @param {any} project_custom_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_emails_update_path = /*#__PURE__*/ __route({"project_custom_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"project_custom_email_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/participants/invite(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_participants_invite_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/participants/invite(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_participants_invite_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/previews/availability(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_previews_availability_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/previews/availability(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_previews_availability_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/previews/confirmation(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_previews_success_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/previews/confirmation(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_previews_success_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/ownership(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_update_ownership_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ownership"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:project_id/ownership(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_update_ownership_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ownership"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-setup-validations/:id/re-run(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const re_run_api_project_project_setup_validation_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-setup-validations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"re-run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/project-setup-validations/:id/re-run(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const re_run_api_project_project_setup_validation_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"project-setup-validations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"re-run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/organization-members/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactivate_api_organization_member_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organization-members/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactivate_api_organization_member_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/recruit-participants-tool(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recruit_participants_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"recruit-participants-tool"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/recruit-participants-tool(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recruit_participants_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"recruit-participants-tool"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/recruitment-process(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recruitment_process_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"recruitment-process"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/recruitment-process(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recruitment_process_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"recruitment-process"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/redeem-incentive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redeem_incentive_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"redeem-incentive"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/redeem-incentive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redeem_incentive_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"redeem-incentive"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reel_page_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /reels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reel_page_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/how-do-i-refer-someone-to-user-interviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referral_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"how-do-i-refer-someone-to-user-interviews"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/how-do-i-refer-someone-to-user-interviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referral_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"how-do-i-refer-someone-to-user-interviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /referral-sweepstakes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referral_sweepstakes_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"referral-sweepstakes"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /referral-sweepstakes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referral_sweepstakes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"referral-sweepstakes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /auth/remove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_oauth_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /auth/remove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_oauth_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/requesting-invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requesting_invoices_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"requesting-invoices"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/requesting-invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requesting_invoices_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"requesting-invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants/:id/reschedule(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reschedule_api_project_participant_url = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/participants/:id/reschedule(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reschedule_api_project_participant_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /research-hub(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const research_hub_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /research-hub(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const research_hub_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /support/rh-csv-upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const research_hub_csv_upload_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"rh-csv-upload"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/rh-csv-upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const research_hub_csv_upload_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"rh-csv-upload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/research-hub-participant-experience(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const research_hub_participant_experience_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"research-hub-participant-experience"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/research-hub-participant-experience(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const research_hub_participant_experience_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"research-hub-participant-experience"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support-topic/researcher-accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_accounts_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-topic"],[2,[7,"/"],[2,[6,"researcher-accounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support-topic/researcher-accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_accounts_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-topic"],[2,[7,"/"],[2,[6,"researcher-accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_onboarding_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_onboarding_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /support/researcher-referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_referrals_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"researcher-referrals"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/researcher-referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_referrals_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"researcher-referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participants/:participant_id/schedule(.:format)
 * @param {any} id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_schedule_participant_url = /*#__PURE__*/ __route({"id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participants/:participant_id/schedule(.:format)
 * @param {any} id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_schedule_participant_path = /*#__PURE__*/ __route({"id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/participants/:participant_id/schedule(.:format)
 * @param {any} id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_submit_schedule_participant_url = /*#__PURE__*/ __route({"id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/participants/:participant_id/schedule(.:format)
 * @param {any} id
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_submit_schedule_participant_path = /*#__PURE__*/ __route({"id":{"r":true},"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support-category/researcher-resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-category"],[2,[7,"/"],[2,[6,"researcher-resources"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support-category/researcher-resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-category"],[2,[7,"/"],[2,[6,"researcher-resources"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /researcher-support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_support_root_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"researcher-support"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /researcher-support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_support_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"researcher-support"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /legal/terms-and-conditions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_terms_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[2,[6,"terms-and-conditions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /legal/terms-and-conditions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const researcher_terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[2,[6,"terms-and-conditions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_url = /*#__PURE__*/ __route({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const safely_redirect_with_flash_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const safely_redirect_with_flash_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /saml/consume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_consumer_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"consume"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /saml/consume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_consumer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"consume"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /saml/join(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_join_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /saml/join(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_join_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /saml/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_metadata_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /saml/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saml_metadata_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scheduling(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduling_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"scheduling"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /scheduling(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduling_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"scheduling"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /support/creating-my-screener-survey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screener_survey_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"creating-my-screener-survey"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/creating-my-screener-survey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screener_survey_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"creating-my-screener-survey"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /research-hub/participants/:participant_id(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_participant_profile_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /research-hub/participants/:participant_id(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_participant_profile_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /research-hub/participants/:participant_id/edit(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_participant_profile_edit_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /research-hub/participants/:participant_id/edit(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_participant_profile_edit_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /research-hub/participants/:participant_id/:active_tab(.:format)
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_participant_profile_tab_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /research-hub/participants/:participant_id/:active_tab(.:format)
 * @param {any} participant_id
 * @param {any} active_tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_participant_profile_tab_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"active_tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[3,"active_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /research-hub/participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_participants_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /research-hub/participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_participants_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"research-hub"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /messages/send_message(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_message_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"send_message"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /messages/send_message(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_message_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"send_message"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_verification_email_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /participants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_verification_email_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /session-clips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_clip_page_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"session-clips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /session-clips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_clip_page_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"session-clips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/page-templates/:page_name(.:format)
 * @param {any} page_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_team_page_template_url = /*#__PURE__*/ __route({"page_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"page-templates"],[2,[7,"/"],[2,[3,"page_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/page-templates/:page_name(.:format)
 * @param {any} page_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_team_page_template_path = /*#__PURE__*/ __route({"page_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"page-templates"],[2,[7,"/"],[2,[3,"page_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signature-requests/:signature_request_id/document(.:format)
 * @param {any} signature_request_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_request_document_url = /*#__PURE__*/ __route({"signature_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signature-requests"],[2,[7,"/"],[2,[3,"signature_request_id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /signature-requests/:signature_request_id/document(.:format)
 * @param {any} signature_request_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_request_document_path = /*#__PURE__*/ __route({"signature_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signature-requests"],[2,[7,"/"],[2,[3,"signature_request_id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signin_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /staff/data-tasks/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_data_task_url = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-tasks"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /staff/data-tasks/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_data_task_path = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-tasks"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /staff/data-tasks/:slug/attempts/:attempt_id(.:format)
 * @param {any} slug
 * @param {any} attempt_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_data_task_attempt_url = /*#__PURE__*/ __route({"slug":{"r":true},"attempt_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-tasks"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"attempts"],[2,[7,"/"],[2,[3,"attempt_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /staff/data-tasks/:slug/attempts/:attempt_id(.:format)
 * @param {any} slug
 * @param {any} attempt_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_data_task_attempt_path = /*#__PURE__*/ __route({"slug":{"r":true},"attempt_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-tasks"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"attempts"],[2,[7,"/"],[2,[3,"attempt_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff/data-tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_data_tasks_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-tasks"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /staff/data-tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_data_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"data-tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /staff/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_signin_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /staff/signin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_signin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"signin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /staff/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_tasks_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /staff/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staff_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/start(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_api_project_ai_moderated_interview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/start(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_api_project_ai_moderated_interview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/start(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_api_qualification_check_ai_moderated_interview_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/start(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_api_qualification_check_ai_moderated_interview_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_project_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_project_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/:access_code/apply(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_projects_apply_url = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:access_code/apply(.:format)
 * @param {any} access_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_projects_apply_path = /*#__PURE__*/ __route({"access_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"access_code"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions/:id/summary(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_api_participant_incentives_redemption_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/participant_incentives/redemptions/:id/summary(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_api_participant_incentives_redemption_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"participant_incentives"],[2,[7,"/"],[2,[6,"redemptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/settings/system-hidden-at(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const system_hidden_at_api_project_settings_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"system-hidden-at"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/settings/system-hidden-at(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const system_hidden_at_api_project_settings_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"system-hidden-at"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tag-targeting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_targeting_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tag-targeting"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /tag-targeting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_targeting_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tag-targeting"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tag-targeting/projects/:project_id(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_targeting_projects_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tag-targeting"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /tag-targeting/projects/:project_id(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_targeting_projects_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tag-targeting"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tag-targeting/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_targeting_search_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tag-targeting"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tag-targeting/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_targeting_search_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tag-targeting"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/advanced-options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_advanced_options_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"advanced-options"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/advanced-options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_advanced_options_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"advanced-options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_billing_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_billing_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/billing-info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_billing_info_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"billing-info"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/billing-info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_billing_info_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"billing-info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/branding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_branding_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/branding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_branding_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"branding"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/consent-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_documents_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"consent-settings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/consent-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"consent-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/domain-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_domain_settings_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"domain-settings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/domain-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_domain_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"domain-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/email_addresses(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_addresses_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/:team_id/email_addresses(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_addresses_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/email-domains/:email_domain_id(.:format)
 * @param {any} team_id
 * @param {any} email_domain_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_domain_url = /*#__PURE__*/ __route({"team_id":{"r":true},"email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email-domains"],[2,[7,"/"],[2,[3,"email_domain_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/:team_id/email-domains/:email_domain_id(.:format)
 * @param {any} team_id
 * @param {any} email_domain_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_domain_path = /*#__PURE__*/ __route({"team_id":{"r":true},"email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email-domains"],[2,[7,"/"],[2,[3,"email_domain_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/email-domains(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_domains_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email-domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/:team_id/email-domains(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_domains_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email-domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/email_profiles/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_profile_url = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/:team_id/email_profiles/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_profile_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/email_profiles(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_profiles_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/:team_id/email_profiles(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_profiles_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/email-templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_templates_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"email-templates"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/email-templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_email_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"email-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_members_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_members_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_notes_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_notes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/page-templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_page_templates_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"page-templates"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/page-templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_page_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"page-templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_reports_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/team-reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_reports_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"team-reports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/team-reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_reports_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"team-reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/saml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_saml_configurations_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/saml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_saml_configurations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/team-scheduling(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_scheduling_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"team-scheduling"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/team-scheduling(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_scheduling_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"team-scheduling"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/recruit-participants(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_sourced_participants_url = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"recruit-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/:team_id/recruit-participants(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_sourced_participants_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"recruit-participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team-subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_subscription_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /team-subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team-subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_templates_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teams/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/token(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const token_api_project_ai_moderated_interview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/token(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const token_api_project_ai_moderated_interview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/token(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const token_api_qualification_check_ai_moderated_interview_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/token(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const token_api_qualification_check_ai_moderated_interview_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support-topic/tools-integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_integrations_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-topic"],[2,[7,"/"],[2,[6,"tools-integrations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support-topic/tools-integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_integrations_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support-topic"],[2,[7,"/"],[2,[6,"tools-integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/undo_do_not_pay_canceled_participant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undo_do_not_pay_canceled_participant_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_do_not_pay_canceled_participant"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/:id/undo_do_not_pay_canceled_participant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undo_do_not_pay_canceled_participant_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_do_not_pay_canceled_participant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support/update-credit-card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_credit_card_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"update-credit-card"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/update-credit-card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_credit_card_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"update-credit-card"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /participants/filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_participant_population_search_filter_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_participant_population_search_filter_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/:participant_id/profiles(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_participant_profile_url = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /participants/:participant_id/profiles(.:format)
 * @param {any} participant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_participant_profile_path = /*#__PURE__*/ __route({"participant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[3,"participant_id"],[2,[7,"/"],[2,[6,"profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /participants/update_recruitment_information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_participant_recruitment_information_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"update_recruitment_information"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /participants/update_recruitment_information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_participant_recruitment_information_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"participants"],[2,[7,"/"],[2,[6,"update_recruitment_information"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /support/update-sender-profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_sender_profile_support_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"update-sender-profile"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /support/update-sender-profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_sender_profile_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"update-sender-profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/reports/:id/url(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_api_organization_report_url = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organizations/:organization_id/reports/:id/url(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_api_organization_report_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_url = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/organization-members/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_api_organization_member_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/organization-members/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_api_organization_member_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organization-members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/team-members/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_api_team_member_url = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/team-members/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_api_team_member_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"team-members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/email-domains/:email_domain_id/verify(.:format)
 * @param {any} team_id
 * @param {any} email_domain_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_team_email_domain_url = /*#__PURE__*/ __route({"team_id":{"r":true},"email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email-domains"],[2,[7,"/"],[2,[3,"email_domain_id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teams/:team_id/email-domains/:email_domain_id/verify(.:format)
 * @param {any} team_id
 * @param {any} email_domain_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_team_email_domain_path = /*#__PURE__*/ __route({"team_id":{"r":true},"email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"email-domains"],[2,[7,"/"],[2,[3,"email_domain_id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/voice_preview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voice_preview_api_project_ai_moderated_interview_url = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"voice_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/projects/:project_id/ai_moderated_interview/voice_preview(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voice_preview_api_project_ai_moderated_interview_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"voice_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/voice_preview(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voice_preview_api_qualification_check_ai_moderated_interview_url = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"voice_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/qualification-checks/:qualification_check_slug/ai_moderated_interview/voice_preview(.:format)
 * @param {any} qualification_check_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voice_preview_api_qualification_check_ai_moderated_interview_path = /*#__PURE__*/ __route({"qualification_check_slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"qualification-checks"],[2,[7,"/"],[2,[3,"qualification_check_slug"],[2,[7,"/"],[2,[6,"ai_moderated_interview"],[2,[7,"/"],[2,[6,"voice_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

